// @ts-nocheck
/***********************************************************************
                            Configuration
***********************************************************************/

window.neviosConfig = window.neviosConfig || {};

/***********************************************************************
                        Nevios Component Initialization
***********************************************************************/

/**
 * Initialize all Nevios checkbox components
 * Checkboxes dispatch custom events when their state changes
 */
window.neviosCheckout__initCheckboxes = function() {
  document.querySelectorAll('[data-nevios-checkbox]').forEach(function(checkbox) {
    if (checkbox.hasAttribute('data-nevios-initialized')) return;
    checkbox.setAttribute('data-nevios-initialized', 'true');
    
    checkbox.addEventListener('change', function(event) {
      var checkboxId = checkbox.id;
      var checkboxStateEvent = new CustomEvent('checkboxChange_' + checkboxId, {
        detail: { checked: event.target.checked }
      });
      document.dispatchEvent(checkboxStateEvent);
    });
  });
};

/**
 * Initialize all Nevios selector/toggle components
 */
window.neviosCheckout__initSelectors = function() {
  document.querySelectorAll('[data-nevios-selector]').forEach(function(wrapper) {
    if (wrapper.hasAttribute('data-nevios-initialized')) return;
    wrapper.setAttribute('data-nevios-initialized', 'true');
    
    var items = wrapper.querySelectorAll('.nevios-selector-type-item');
    items.forEach(function(item) {
      item.addEventListener('click', function() {
        items.forEach(function(i) { i.classList.remove('active'); });
        item.classList.add('active');
        
        var selectedType = item.dataset.type;
        wrapper.dataset.selected = selectedType;
        
        var selectorEvent = new CustomEvent('selectorChange', {
          detail: { type: selectedType, wrapper: wrapper }
        });
        document.dispatchEvent(selectorEvent);
      });
    });
  });
};

/**
 * Initialize all Nevios phone input components
 */
window.neviosCheckout__initPhoneInputs = function() {
  var defaultCountries = [
    { id: 'cz', flag: '🇨🇿', prefix: '+420', name: 'Česká republika', pattern: '\\d{3}\\s\\d{3}\\s\\d{3}', maxDigits: 9 },
    { id: 'sk', flag: '🇸🇰', prefix: '+421', name: 'Slovensko', pattern: '\\d{3}\\s\\d{3}\\s\\d{3}', maxDigits: 9 }
  ];
  
  document.querySelectorAll('[data-nevios-phone]').forEach(function(wrapper) {
    if (wrapper.hasAttribute('data-nevios-initialized')) return;
    wrapper.setAttribute('data-nevios-initialized', 'true');
    
    var uid = wrapper.getAttribute('data-nevios-phone');
    var countries = defaultCountries;
    var current = countries[0];
    
    var flagEl = wrapper.querySelector('.selected-flag');
    var codeEl = wrapper.querySelector('.country-code');
    var listEl = wrapper.querySelector('.nevios_phone_country_list');
    var checkbox = wrapper.querySelector('.dropdown-checkbox');
    var phoneInput = wrapper.querySelector('.nevios_phone_input');
    
    if (!flagEl || !codeEl || !listEl || !phoneInput) return;
    
    countries.forEach(function(c) {
      var li = document.createElement('li');
      li.innerHTML = '<span>' + c.flag + '</span> ' + c.name + ' (' + c.prefix + ')';
      li.addEventListener('click', function() {
        current = c;
        flagEl.textContent = c.flag;
        codeEl.textContent = c.prefix;
        phoneInput.setAttribute('data-pattern', c.pattern);
        if (checkbox) checkbox.checked = false;
        phoneInput.value = '';
      });
      listEl.appendChild(li);
    });
    
    flagEl.textContent = current.flag;
    codeEl.textContent = current.prefix;
    phoneInput.setAttribute('data-pattern', current.pattern);
    
    phoneInput.addEventListener('input', function() {
      var raw = this.value.replace(/\D/g, '').slice(0, current.maxDigits);
      var parts = [];
      for (var i = 0; i < raw.length; i += 3) {
        parts.push(raw.slice(i, i + 3));
      }
      this.value = parts.join(' ');
    });
    
    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-nevios-phone="' + uid + '"]')) {
        if (checkbox) checkbox.checked = false;
      }
    });
  });
};

/**
 * Initialize all Nevios components
 * Call this on DOMContentLoaded or after dynamic content is added
 */
window.neviosCheckout__initComponents = function() {
  window.neviosCheckout__initCheckboxes();
  window.neviosCheckout__initSelectors();
  window.neviosCheckout__initPhoneInputs();
};

window.neviosConfig = {
    czechia: {
      market: 'vasky/czechia',
      market_currency: 'vasky/czechia/CZK',
      domains: ['vasky.cz', 'www.vasky.cz', 'vaskyshoes.com', 'www.vaskyshoes.com'],
      currency: 'CZK',
      currency_symbol: 'Kč',
      defaultCountry: 'CZ',
      language: 'cs-CZ'
    },
    slovakia: {
      market: 'vasky/slovakia',
      market_currency: 'vasky/slovakia/EUR',
      domains: ['vasky.sk', 'www.vasky.sk', 'sk.vasky.cz'],
      currency: 'EUR',
      currency_symbol: '€',
      defaultCountry: 'SK',
      language: 'sk-SK'
    },
    international: {
      market: 'vasky/international',
      market_currency: 'vasky/international/USD',
      domains: [],
      currency: 'USD',
      currency_symbol: '$',
      defaultCountry: 'US',
      language: 'en-US'
    }
  };
  
  window.neviosConfig.getCurrentMarket = function() {
    var currentDomain = window.location.hostname;
    
    // Loop through each market to find a matching domain
    for (var key in this) {
      if (this.hasOwnProperty(key) && typeof this[key] === 'object' && this[key].domains) {
        if (this[key].domains.indexOf(currentDomain) !== -1) {
          return { ...this[key], marketKey: key };
        }
      }
    }
    
    // Fallback to international if no domain match is found
    return { ...this.international, marketKey: 'international' };
  };
  
  /***********************************************************************
                                DOM Loaded
  ***********************************************************************/
  
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all Nevios components
  window.neviosCheckout__initComponents();
  
  // Check if checkout section exists on the page (works in both storefront and theme editor)
  var checkoutSection = document.querySelector('.nch_section');
  
  if (checkoutSection) {
    // Skip API calls in theme editor to prevent constant refreshing
    if (window.Shopify && window.Shopify.designMode) {
      neviosCheckout__initDesignMode();
    } else {
      neviosCheckout__init();
    }
  }
});

// Listen for Shopify theme editor section reload events
document.addEventListener('shopify:section:load', function(event) {
  // Check if the reloaded section is our checkout section
  if (event.target && event.target.querySelector('.nch_section')) {
    console.log("[Nevios Checkout] Section reloaded in theme editor");
    // Re-initialize components for the new section
    window.neviosCheckout__initComponents();
    // Re-run design mode initialization
    if (window.Shopify && window.Shopify.designMode) {
      neviosCheckout__initDesignMode();
    }
  }
});

/**
 * Design Mode initialization with mock data
 * Used when editing in Shopify theme editor to prevent API calls and refreshing
 */
window.neviosCheckout__initDesignMode = function() {
  console.log("[Nevios Checkout] Design mode initializing...");
  
  try {
    // Hide loading skeleton immediately
    var loadingEl = document.querySelector('.nch_loading');
    if (loadingEl) {
      loadingEl.classList.add('hidden');
    }
    
    // Render mock cart items using simple format (avoiding price formatting issues)
    var cartContainer = document.querySelector('[data-cart-items]');
    if (cartContainer) {
      cartContainer.innerHTML = `
        <cart-item class="nch_item_vertical">
          <div class="nch_item_vertical_image">
            <div class="nch_item_vertical_image_wrapper">
              <img src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png" alt="Product">
            </div>
          </div>
          <div class="nch_item_vertical_info">
            <span class="nch_item_vertical_info_title caption2">Ukázkový produkt</span>
            <span class="nch_item_vertical_info_variant body4 body-color">Velikost: 42</span>
            <span class="nch_item_vertical_info_quantity body4 body-color">Množství: 1</span>
          </div>
          <div class="nch_item_vertical_pricing">
            <span class="nch_item_vertical_pricing_price">2&nbsp;999&nbsp;Kč</span>
          </div>
        </cart-item>
        <cart-item class="nch_item_vertical">
          <div class="nch_item_vertical_image">
            <div class="nch_item_vertical_image_wrapper">
              <img src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-2_large.png" alt="Product">
            </div>
          </div>
          <div class="nch_item_vertical_info">
            <span class="nch_item_vertical_info_title caption2">Další produkt</span>
            <span class="nch_item_vertical_info_variant body4 body-color">Barva: Černá</span>
            <span class="nch_item_vertical_info_quantity body4 body-color">Množství: 2</span>
          </div>
          <div class="nch_item_vertical_pricing">
            <span class="nch_item_vertical_pricing_price">1&nbsp;499&nbsp;Kč</span>
          </div>
        </cart-item>
      `;
    }
    
    // Render mock pricing directly (avoiding function calls that might fail)
    var subtotalEl = document.querySelector('.nch_pricing_line[data-pricing="subtotal"]');
    var shippingEl = document.querySelector('.nch_pricing_line[data-pricing="shipping"]');
    var totalEl = document.querySelector('.nch_pricing_line[data-pricing="total"]');
    
    if (subtotalEl) {
      subtotalEl.classList.add('visible');
      var subtotalVal = subtotalEl.querySelector('.nch_pricing_line_value');
      if (subtotalVal) subtotalVal.innerHTML = '5&nbsp;997&nbsp;Kč';
    }
    
    if (shippingEl) {
      shippingEl.classList.add('visible');
      var shippingVal = shippingEl.querySelector('.nch_pricing_line_value');
      if (shippingVal) shippingVal.innerHTML = '79&nbsp;Kč';
    }
    
    if (totalEl) {
      totalEl.classList.add('visible');
      var totalVal = totalEl.querySelector('.nch_pricing_line_value');
      if (totalVal) totalVal.innerHTML = '6&nbsp;076&nbsp;Kč';
    }
    
    // Render mock shipping options directly
    var shippingContainer = document.querySelector('.nch_shipping_container');
    if (shippingContainer) {
      shippingContainer.innerHTML = `
        <div class="nch_shipping_section">
          <div class="nch_shipping_section_header expanded">
            <div class="nch_shipping_section_header_content">
              <img src="https://cdn.shopify.com/s/files/1/0870/6621/4730/files/truck-speed-svgrepo-com.svg?v=1770896797" alt="Delivery" class="nch_shipping_section_icon">
              <span class="nch_shipping_section_title">Kurýrem</span>
              <span class="nch_shipping_section_count">(2 možnosti)</span>
            </div>
            <svg class="nch_shipping_section_arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="nch_shipping_section_content">
            <label class="nch_shipping_option">
              <div class="nch_shipping_option_content">
                <input type="radio" name="shipping" class="nch_shipping_radio" value="mock-1" shipping-type="POINT">
                <span class="nch_shipping_custom-radio"></span>
                <div class="nch_shipping_label">
                  <div class="nch_shipping_info">
                    <span class="nch_shipping_title">Zásilkovna</span>
                    <span class="nch_shipping_description">Doručení na výdejní místo</span>
                  </div>
                  <div class="nch_shipping_price-container">
                    <span class="nch_shipping_price">79&nbsp;Kč</span>
                  </div>
                </div>
              </div>
            </label>
            <label class="nch_shipping_option">
              <div class="nch_shipping_option_content">
                <input type="radio" name="shipping" class="nch_shipping_radio" value="mock-2" shipping-type="HOME">
                <span class="nch_shipping_custom-radio"></span>
                <div class="nch_shipping_label">
                  <div class="nch_shipping_info">
                    <span class="nch_shipping_title">Česká pošta</span>
                    <span class="nch_shipping_description">Doručení na adresu</span>
                  </div>
                  <div class="nch_shipping_price-container">
                    <span class="nch_shipping_price">99&nbsp;Kč</span>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
        <div class="nch_shipping_section">
          <div class="nch_shipping_section_header">
            <div class="nch_shipping_section_header_content">
              <img src="https://cdn.shopify.com/s/files/1/0870/6621/4730/files/store-2-svgrepo-com.svg?v=1770896797" alt="Pickup" class="nch_shipping_section_icon">
              <span class="nch_shipping_section_title">Osobní odběr</span>
              <span class="nch_shipping_section_count">(1 prodejna)</span>
            </div>
            <svg class="nch_shipping_section_arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="nch_shipping_section_content collapsed">
            <label class="nch_shipping_option">
              <div class="nch_shipping_option_content">
                <input type="radio" name="shipping" class="nch_shipping_radio" value="mock-3" shipping-type="STORE">
                <span class="nch_shipping_custom-radio"></span>
                <div class="nch_shipping_label">
                  <div class="nch_shipping_info">
                    <span class="nch_shipping_title">Praha</span>
                    <span class="nch_shipping_description">Na Příkopě 123</span>
                  </div>
                  <div class="nch_shipping_price-container">
                    <span class="nch_shipping_price">Zdarma</span>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
      `;
      shippingContainer.classList.add('fade-in');
    }
    
    // Mock payment options
    var paymentContainer = document.querySelector('.nch_payment_container');
    if (paymentContainer) {
      paymentContainer.innerHTML = `
        <label class="nch_payment_option">
          <div class="nch_payment_option_content">
            <input type="radio" name="payment" class="nch_payment_radio" value="mock-card" checked>
            <span class="nch_payment_custom-radio"></span>
            <div class="nch_payment_label">
              <div class="nch_payment_info">
                <span class="nch_payment_title">Platba kartou</span>
              </div>
              <div class="nch_payment_price-container">
                <span class="nch_payment_price">Zdarma</span>
              </div>
            </div>
          </div>
        </label>
        <label class="nch_payment_option">
          <div class="nch_payment_option_content">
            <input type="radio" name="payment" class="nch_payment_radio" value="mock-cod">
            <span class="nch_payment_custom-radio"></span>
            <div class="nch_payment_label">
              <div class="nch_payment_info">
                <span class="nch_payment_title">Dobírka</span>
              </div>
              <div class="nch_payment_price-container">
                <span class="nch_payment_price">39&nbsp;Kč</span>
              </div>
            </div>
          </div>
        </label>
      `;
      paymentContainer.classList.add('fade-in');
    }
    
    console.log("[Nevios Checkout] Design mode active - using mock data");
  } catch (error) {
    console.error("[Nevios Checkout] Design mode error:", error);
  }
};
  
  /***********************************************************************
                                Helper
  ***********************************************************************/
  window.neviosCheckout__setCookie = function(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
  };
  window.neviosCheckout__getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  };
  
  window.neviosCheckout__deleteCookie = function(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  };
  
  window.neviosCheckout__insert = function(insertId, value, options) {
    options = options || {};
    var animate = options.animate; // e.g., "typing"
    var typingSpeed = options.typingSpeed || 50;
    var content = "";
    
    if (options.format && options.format === "money") {
      // Convert the received value (expected to be in minor units) using parseInt.
      var num = parseInt(value, 10) || 0;
      var major = num / 100;
      var formattedNumber = "";
      
      // Get current market configuration
      var currentMarket = window.neviosConfig.getCurrentMarket();
      
      // If there are no cents, format without decimals.
      if (num % 100 === 0) {
        formattedNumber = major.toLocaleString(currentMarket.language, { 
          minimumFractionDigits: 0, 
          maximumFractionDigits: 0 
        });
      } else {
        formattedNumber = major.toLocaleString(currentMarket.language, { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
        });
      }
      
      // Build the content: formatted number + non-breaking space + currency symbol.
      content = formattedNumber + "&nbsp;" + currentMarket.currency_symbol;
    } else {
      // Normal content building.
      var name = options.name;
      var unit = options.unit;
      var unitplacement = options.unitplacement ? options.unitplacement.toLowerCase() : 'after';
      
      if (name) {
        content += name + ":&nbsp;";
      }
      if (unit) {
        if (unitplacement === "before") {
          content += unit + "&nbsp;" + value;
        } else {
          content += value + "&nbsp;" + unit;
        }
      } else {
        content += value;
      }
    }
    
    // Find all elements with the specified data-insert-id.
    var elements = document.querySelectorAll('[data-insert-id="' + insertId + '"]');
    
    elements.forEach(function(el) {
      // Determine if the element is an input of type "text".
      var isInputText = (el.tagName.toLowerCase() === "input" &&
                         el.getAttribute("type") &&
                         el.getAttribute("type").toLowerCase() === "text");
      
      if (animate === "typing" && !isInputText) {
        // For typing animation, insert the text one character at a time.
        var finalText = isInputText ? content.replace(/&nbsp;/g, " ") : content;
        animateTyping(el, finalText, 0, isInputText, typingSpeed);
      } else {
        // No animation: update immediately.
        if (isInputText) {
          el.value = content.replace(/&nbsp;/g, " ");
        } else {
          el.innerHTML = content;
        }
      }
    });
    
    function animateTyping(el, fullText, index, isInput, speed) {
      if (index <= fullText.length) {
        var currentText = fullText.substring(0, index);
        if (isInput) {
          el.value = currentText;
        } else {
          el.innerHTML = currentText;
        }
        setTimeout(function() {
          animateTyping(el, fullText, index + 1, isInput, speed);
        }, speed);
      }
    }
  };
  
  window.neviosCheckout__returnFormatMoney = function(value) {
    var num = parseInt(value, 10) || 0;
    
    // Show "Zdarma" for free items
    if (num === 0) {
      return "Zdarma";
    }
    
    var major = num / 100;
    var formattedNumber = "";
    
    // Get current market configuration
    var currentMarket = window.neviosConfig.getCurrentMarket();
  
    if (num % 100 === 0) {
      formattedNumber = major.toLocaleString(currentMarket.language, { 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 0 
      });
    } else {
      formattedNumber = major.toLocaleString(currentMarket.language, { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    }
  
    return formattedNumber + "\u00A0" + currentMarket.currency_symbol;
  };
  
  window.neviosCheckout__initInputFormatting = function() {
    // Find all input elements with type text and a data-format attribute.
    var inputs = document.querySelectorAll('input[type="text"][data-format]');
    
    inputs.forEach(function(input) {
      input.addEventListener("input", function() {
        // Remove any non-digit characters.
        var digits = input.value.replace(/\D/g, "");
        
        // Limit to a maximum of 5 digits.
        digits = digits.substring(0, 5);
        
        // Auto-insert a space after the first 3 digits if there are more than 3.
        var formatted = digits;
        if (digits.length > 3) {
          formatted = digits.substring(0, 3) + " " + digits.substring(3);
        }
        
        // Update the input's value with the formatted string.
        input.value = formatted;
      });
    });
  };
  
  window.neviosCheckout__addClass = function(elementSelector, className) {
    var elements;
    if (elementSelector.charAt(0) === "#") {
      // Remove the '#' and get the element by ID.
      var el = document.getElementById(elementSelector.substring(1));
      if (el) {
        el.classList.add(className);
      }
    } else if (elementSelector.charAt(0) === ".") {
      // Use querySelectorAll to get all elements by class.
      elements = document.querySelectorAll(elementSelector);
      elements.forEach(function(el) {
        el.classList.add(className);
      });
    } else if (elementSelector.indexOf("data-") === 0) {
      // If it starts with "data-", find elements with that attribute.
      elements = document.querySelectorAll("[" + elementSelector + "]");
      elements.forEach(function(el) {
        el.classList.add(className);
      });
    } else {
      // Fallback: use the elementSelector as a query selector.
      elements = document.querySelectorAll(elementSelector);
      elements.forEach(function(el) {
        el.classList.add(className);
      });
    }
  };
  
  window.neviosCheckout__removeClass = function(elementSelector, className) {
    var elements;
    if (elementSelector.charAt(0) === "#") {
      var el = document.getElementById(elementSelector.substring(1));
      if (el) {
        el.classList.remove(className);
      }
    } else if (elementSelector.charAt(0) === ".") {
      elements = document.querySelectorAll(elementSelector);
      elements.forEach(function(el) {
        el.classList.remove(className);
      });
    } else if (elementSelector.indexOf("data-") === 0) {
      elements = document.querySelectorAll("[" + elementSelector + "]");
      elements.forEach(function(el) {
        el.classList.remove(className);
      });
    } else {
      elements = document.querySelectorAll(elementSelector);
      elements.forEach(function(el) {
        el.classList.remove(className);
      });
    }
  };
  
  window.neviosCheckout__fetchShopifyCart = function() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Error fetching Shopify cart data');
      }
      return response.json();
    })
    .then(function(cartData) {
      return cartData;
    })
    .catch(function(error) {
      console.error('Error fetching Shopify cart data:', error);
      throw error;
    });
  };
  
  window.neviosCheckout__postAddShopifyCartItem = function(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity
      })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          throw new Error(errorData.description || 'Error adding item to cart');
        });
      }
      return response.text();
    })
    .then(text => {
      try {
        const json = JSON.parse(text);
        console.log("Shopify cart add response (JSON):", json);
      } catch (error) {
        console.log("Shopify cart add response:", text);
      }
      return text;
    })
    .catch(error => {
      console.error("Error in neviosCheckout__postAddShopifyCartItem:", error);
      throw error;
    });
  };
  
  /***********************************************************************
                                Checkout
  ***********************************************************************/
  
  window.neviosCheckout__init = function() {
    var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
  
    // First fetch the Shopify cart data
    Promise.resolve().then(function(){return window.nvEngravingGuard ? window.nvEngravingGuard() : null;}).then(function(){return window.nvBagGiftSync ? window.nvBagGiftSync() : null;}).then(function(){return window.neviosCheckout__fetchShopifyCart();})
      .then(function(shopifyCart) {
        // Map Shopify cart items to the expected format
        var cartItems = [];
        
        if (shopifyCart && Array.isArray(shopifyCart.items)) {
          cartItems = shopifyCart.items.map(function(item) {
            var mapped = {
              "variant_eid": item.id,  // Shopify variant ID
              "quantity": item.quantity
            };
            // Forward Shopify line item properties as Nevios `parameters` so
            // engraving text (Ražba) survives into order_item.parameters and
            // is emitted as row.x_razba_text by the AbraGen connector.
            if (item.properties && typeof item.properties === 'object') {
              var params = [];
              Object.keys(item.properties).forEach(function (k) {
                if (k && (k.charAt(0) !== '_' || k === '_nv_bag_preview')) {  // skip Shopify internal _props
                  var v = item.properties[k];
                  if (v !== null && v !== undefined && String(v).trim() !== '') {
                    params.push({ key: k, value: String(v).trim() });
                  }
                }
              });
              if (params.length > 0) mapped.parameters = params;
            }
            return mapped;
          });
        }
  
        console.log('Mapped cart items from Shopify:', cartItems);

        // Redirect to homepage if cart is empty
        if (!cartItems || cartItems.length === 0) {
          console.log('Cart is empty, redirecting to homepage');
          window.location.href = '/';
          return;
        }

        // Resolve market from current domain — SK customers on vasky.sk/sk.vasky.cz
        // get vasky/slovakia/EUR; CZ customers get vasky/czechia/CZK. Falls back
        // to international if domain isn't recognised.
        var currentMarket = (window.neviosConfig && typeof window.neviosConfig.getCurrentMarket === 'function')
          ? window.neviosConfig.getCurrentMarket()
          : { market_currency: 'vasky/czechia/CZK', defaultCountry: 'CZ' };

        var payload = {
          "market_currency": currentMarket.market_currency,
          "cart_items": cartItems,
          "country": currentMarket.defaultCountry
        };

        // Include checkout ID if it exists
        if (checkoutId) {
          payload.checkoutId = checkoutId;
        }

        // Pass session ID for UTM attribution tracking
        var sessionId = window.analytics && window.analytics.sessionId
          ? window.analytics.sessionId
          : null;
        if (!sessionId) {
          // Fallback: read from cookie directly in case analytics hasn't init'd yet
          var cookieMatch = document.cookie.match(/(?:^|;\s*)_analytics_session_id=([^;]+)/);
          if (cookieMatch) sessionId = cookieMatch[1];
        }
        if (sessionId) {
          payload.session = sessionId;
        }
  
        // Single API call to init endpoint
        return fetch(`/a/api/storefront/checkout/init`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      })
      .then(function(response) { 
        return response.json(); 
      })
      .then(function(data) {
        if (data.success) {
          // Store checkout ID in cookie
          window.neviosCheckout__setCookie("neviosCheckout", data.data.checkout.id, 7);
          
          // Store global data
          window.requestData = data.data.checkout;
          window.marketDetails = data.data.checkout.market_details;
          window.isNewCheckout = data.data.is_new_checkout;
          
          // Render content with all data available immediately
          neviosCheckout__renderContent(data, "vasky/czechia/CZK", "CZ");
        } else {
          console.error("Failed to initialize checkout:", data);
        }
      })
      .catch(function(err) {
        console.error("Error initializing checkout:", err);
      });
  };
  
  /**
   * Perform actions once we get the data from the server
   * 
   * Now optimized to work with the init endpoint response structure
   */
  window.neviosCheckout__renderContent = function(data, marketCurrency, selectedCountry) {
    neviosCheckout__renderCartItems(data.data.checkout.cart_items);
    neviosCheckout__updateAllPricing(data.data.checkout.pricing);
    neviosCheckout__retrieveData(data.data.checkout);
    neviosCheckout__renderShippingOptions(data.data.shipping_methods);
    neviosCheckout__initDiscount();
    neviosCheckout__initTip();
    neviosCheckout__initEmailAutofill();
    neviosCheckout__wireConfirmButton();
    neviosCheckout__initMobileSummary();
    neviosCheckout__addClass(".nch_loading", "hidden");
  };
  
  /**
   * Update checkout data in the DOM.
   *
   * This function iterates over all elements with the attribute "data-insert-id".
   * For each element, if the provided data object contains a matching key and its value is not empty or null,
   * it calls window.neviosCheckout__insert with the insertId, the corresponding value,
   * and an options object that specifies an animation ("typing").
   *
   * @param {Object} data - The data object containing checkout data to be inserted into the DOM.
   */
  window.neviosCheckout__retrieveData = function(data) {
    var elements = document.querySelectorAll('[data-insert-id]');
    elements.forEach(function(el) {
      var insertId = el.getAttribute('data-insert-id');
      if (data && data.hasOwnProperty(insertId)) {
        var value = data[insertId];
        if (value !== null && value !== '') {
          window.neviosCheckout__insert(insertId, value, { animate: "typing" });
        }
      }
    });
  
    var acceptMarketing = document.getElementById("acceptMarketing");
    if (data.accept_marketing == true) {
      acceptMarketing.checked = true;
      acceptMarketing.dispatchEvent(new Event("change"));
    }
  
    var enterCompany = document.getElementById("enterCompany");
    if (data.company_name || data.company_id || data.company_vat) {
      enterCompany.checked = true;
      enterCompany.dispatchEvent(new Event("change"));
    }
    
    neviosCheckout__initDataSync();
  };
  
  /**
   * Initialize data synchronization for checkout inputs.
   *
   * This function attaches a "change" event listener to every input element that has a
   * "data-insert-id" attribute. When the value of such an input changes (i.e., when the user
   * fills in or modifies the input), the function performs the following steps:
   *
   * 1. Retrieves the key from the "data-insert-id" attribute.
   * 2. Reads the current value of the input.
   * 3. Retrieves the checkout ID from the cookie "neviosCheckout" using a helper function.
   * 4. If a checkout ID exists, it builds a payload object with the key and value.
   * 5. Sends a PUT request to the API endpoint `/a/api/storefront/checkout/update/:checkoutId` to update the data.
   *
   * This function does not call any additional functions after sending the update.
   */
  window.neviosCheckout__initDataSync = function() {
    var inputs = document.querySelectorAll('input[data-insert-id]');
    inputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var key = input.getAttribute('data-insert-id');
        var value = input.value;
        var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
        if (!checkoutId) return;
        var payload = {};
        payload[key] = value;
        fetch(`/a/api/storefront/checkout/update/${checkoutId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function(err) {});
      });
      
      // Clear error state when user starts typing
      input.addEventListener('input', function() {
        if (input.getAttribute('state') === 'error') {
          input.removeAttribute('state');
        }
      });
    });
    
    // Also clear error state on checkboxes when changed
    var checkboxes = document.querySelectorAll('.nevios-checkbox-wrapper input[type="checkbox"]');
    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        var wrapper = checkbox.closest('.nevios-checkbox-wrapper');
        if (wrapper && wrapper.classList.contains('error')) {
          wrapper.classList.remove('error');
        }
      });
    });
  };
  
  /**
   * Initialize email autofill functionality.
   * 
   * When the user enters an email that exists in the database,
   * the backend returns customer data (billing address, name, etc.)
   * and we automatically populate the form fields (excluding email itself).
   */
  window.neviosCheckout__initEmailAutofill = function() {
    var emailInput = document.getElementById('customer_email');
    
    if (!emailInput) return;
    
    emailInput.addEventListener('change', function() {
      var email = emailInput.value.trim();
      var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
      
      if (!checkoutId || !email) return;
      
      // Add loading state
      emailInput.classList.add('loading');
      emailInput.disabled = true;
      
      fetch(`/a/api/storefront/checkout/update/${checkoutId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      })
      .then(function(res) { return res.json(); })
      .then(function(response) {
        if (response.success && response.data) {
          var hasCustomerData = response.data.billing_first_name || 
                                response.data.billing_last_name || 
                                response.data.billing_address;
          
          if (hasCustomerData) {
            console.log('[AUTOFILL] Customer data found, populating fields');
            
            // Populate all fields EXCEPT email
            var elements = document.querySelectorAll('[data-insert-id]');
            elements.forEach(function(el) {
              var insertId = el.getAttribute('data-insert-id');
              
              // Skip email field
              if (insertId === 'email') return;
              
              if (response.data && response.data.hasOwnProperty(insertId)) {
                var value = response.data[insertId];
                if (value !== null && value !== '') {
                  window.neviosCheckout__insert(insertId, value, { animate: "typing" });
                }
              }
            });
            
            // Handle checkboxes
            var acceptMarketing = document.getElementById("acceptMarketing");
            if (response.data.accept_marketing === true) {
              acceptMarketing.checked = true;
              acceptMarketing.dispatchEvent(new Event("change"));
            }
            
            var enterCompany = document.getElementById("enterCompany");
            if (response.data.company_name || response.data.company_id || response.data.company_vat) {
              enterCompany.checked = true;
              enterCompany.dispatchEvent(new Event("change"));
            }
          }
        }
      })
      .catch(function(err) {
        console.error('Error updating email:', err);
      })
      .finally(function() {
        // Remove loading state
        emailInput.classList.remove('loading');
        emailInput.disabled = false;
      });
    });
  };
  
  /***********************************************************************
                             Event Listeners
  ***********************************************************************/
  
  /*
   * Define variables
   */
  window.enterCompany = false;
  window.differentShipping = false;
  window.acceptMarketing = true;
  
  /*
   * This triggers the visibility of company form.
   */
  document.addEventListener('checkboxChange_enterCompany', (e) => {
    if (e.detail.checked) {
      neviosCheckout__addClass(".nch_company_block", "visible");
      window.enterCompany = true;
    } else {
      neviosCheckout__removeClass(".nch_company_block", "visible");
      window.enterCompany = false;
    }
  });
  
  /*
   * This triggers the visibility of different shipping form.
   */
  document.addEventListener('checkboxChange_differentShipping', (e) => {
    if (e.detail.checked) {
      neviosCheckout__addClass(".nch_different_shipping_block", "visible");
      window.differentShipping = true;
    } else {
      neviosCheckout__removeClass(".nch_different_shipping_block", "visible");
      window.differentShipping = false;
    }
  });
  
  /*
   * This triggers the marketing accepted.
   */
  document.addEventListener('checkboxChange_acceptMarketing', (e) => {
    const checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    window.acceptMarketing = e.detail.checked;
    if (!checkoutId) return;
  
    const payload = { accept_marketing: e.detail.checked };
  
    fetch(`/a/api/storefront/checkout/update/${checkoutId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(err => console.error(err));
  });

  /*
   * Heureka "Ověřeno zákazníky" — opt-out.
   *
   * Checked means the customer refuses the satisfaction questionnaire, so the
   * flag is stored the way it is ticked: true = do not report this order.
   * The box is rendered unchecked, which is what Heureka requires, and the
   * server default matches — an order nobody touched is reportable.
   */
  const heurekaOptOutChanged = (e) => {
    const checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) return;

    const payload = { heureka_opt_out: e.detail.checked };

    fetch(`/a/api/storefront/checkout/update/${checkoutId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(err => console.error(err));
  };

  /* Desktop and mobile confirm blocks are both in the DOM, only one visible,
     so each carries its own id — same split as acceptTerms/acceptTermsMobile. */
  document.addEventListener('checkboxChange_heurekaOptOut', heurekaOptOutChanged);
  document.addEventListener('checkboxChange_heurekaOptOutMobile', heurekaOptOutChanged);
  
  /*
   * This triggers the different shipping checkbox.
   */
  document.addEventListener('checkboxChange_differentShipping', (e) => {
    const checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) return;
  
    const payload = { different_shipping: e.detail.checked };
  
    fetch(`/a/api/storefront/checkout/update/${checkoutId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(err => console.error(err));
  });
  
  /*
   * This triggers the country selection dropdown.
   */
  document.addEventListener('DOMContentLoaded', function() {
    var countrySelect = document.getElementById('country');
    
    if (countrySelect) {
      window.selectedCountry = countrySelect.value;
      
      countrySelect.addEventListener('change', function(e) {
        window.selectedCountry = e.target.value;
      });
    }
  });
  
  /***********************************************************************
                                 Cart Items
  ***********************************************************************/
  /**
   * Render cart items based on the provided cartItems array.
   *
   * For each item:
   *  - Always shows the main price.
   *  - Shows the "compare at" price only if item.discounted_condition === true.
   *
   * @param {Array} cartItems - The array of cart item objects to render.
   */
  window.neviosCheckout__renderCartItems = function(cartItems) {
    // Presentation only: retain the service line in checkout/order data and totals.
    function engravingText(item) {
      var p = (Array.isArray(item.parameters) ? item.parameters : []).find(function(p) {
        return p && ['Ražba', 'Mintage', 'engraving'].indexOf(p.key) !== -1;
      });
      return p && typeof p.value === 'string' ? p.value.trim() : '';
    }
    function isEngravingFee(item) {
      return item.variant_sku === 'W-0001-00-00' || String(item.variant_eid) === '62384637247818';
    }
    function escapeText(value) {
      return String(value).replace(/[&<>"']/g, function(c) {
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
      });
    }
    var fees = cartItems.filter(isEngravingFee);
    var engravedQuantity = cartItems.reduce(function(n, item) {
      return n + (!isEngravingFee(item) && engravingText(item) ? Number(item.quantity) : 0);
    }, 0);
    var feeQuantity = fees.reduce(function(n, item) { return n + Number(item.quantity); }, 0);
    var grouped = fees.length === 1 && engravedQuantity > 0 && engravedQuantity === feeQuantity;
    var htmlContent = '<style>[data-cart-items] .nv-checkout-engraving,[data-cart-items-mobile] .nv-checkout-engraving{display:flex;align-items:center;flex-wrap:wrap;gap:4px 6px;margin-top:5px;font-family:Elza,sans-serif!important;font-size:12px;line-height:1.5;color:#526257}[data-cart-items] .nv-checkout-engraving *,[data-cart-items-mobile] .nv-checkout-engraving *{font-family:Elza,sans-serif!important}.nv-checkout-engraving svg{width:13px;height:13px;flex:0 0 13px}.nv-checkout-engraving strong{font-weight:600}[data-cart-items] .nv-cart-stock,[data-cart-items-mobile] .nv-cart-stock{display:none!important}</style>';

    
    cartItems.forEach(function(item) {
      if (grouped && isEngravingFee(item)) return;
      var initials = !isEngravingFee(item) ? engravingText(item) : '';
      var engravingLabel = initials ? '<span class="nv-checkout-engraving"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m15 4 5 5M4 20l5-1L20 8a3.5 3.5 0 0 0-5-5L4 14z"/></svg><span>Ražba: <strong>' + escapeText(initials) + '</strong></span>' + '</span>' : '';

      var engravingUnitPrice = grouped && initials ? Number(fees[0].price) : 0;
      var formattedPrice = window.neviosCheckout__returnFormatMoney(Number(item.price));
      var formattedCompareAtPrice = "";
      
      if (item.discounted_condition) {
        formattedCompareAtPrice = window.neviosCheckout__returnFormatMoney(Number(item.compare_at_price));
      }
      
      htmlContent += `
  <cart-item class="nch_item_vertical">
    <div class="nch_item_vertical_image">
      <div class="nch_item_vertical_image_wrapper">
        <img src="${item.image}">
      </div>
    </div>
    <div class="nch_item_vertical_info">
      <span class="nch_item_vertical_info_title caption2">${item.product_title}</span>
      ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="nch_item_vertical_info_variant body4 body-color">Velikost: ${item.variant_title}</span>` : ''}
      <span class="nch_item_vertical_info_quantity body4 body-color">Množství: ${item.quantity}</span>
      ${engravingLabel}
    </div>
    <div class="nch_item_vertical_pricing" style="display:flex;flex-direction:column;align-items:flex-end;gap:4px">
      ${ item.discounted_condition
        ? `<span class="nch_item_vertical_pricing_price discounted" data-insert-id="price">${formattedPrice}</span>
           <span class="nch_item_vertical_pricing_compare_at_price" data-insert-id="compare_at_price">${formattedCompareAtPrice}</span>`
        : `<span class="nch_item_vertical_pricing_price" data-insert-id="price">${formattedPrice}</span>`
      }
      ${grouped && initials ? `<span class="nv-checkout-engraving-price" style="font-family:Elza,sans-serif;font-size:12px;line-height:1.5;color:#526257;white-space:nowrap" aria-label="Příplatek za ražbu">+ ${escapeText(window.neviosCheckout__returnFormatMoney(engravingUnitPrice))}</span>` : ''}
    </div>
  </cart-item>`;
    });
    
    var container = document.querySelector('[data-cart-items]');
    if (container) {
      container.innerHTML = htmlContent;
    }
    
    // Also update mobile cart items with the same HTML
    var mobileContainer = document.querySelector('[data-cart-items-mobile]');
    if (mobileContainer) {
      mobileContainer.innerHTML = htmlContent;
    }
  };
  
  
  /***********************************************************************
                                Pricing
  ***********************************************************************/
  
  /**
   * Update a specific pricing line on the DOM.
   *
   * This function takes a pricing type and a price value in minor units,
   * finds the corresponding DOM element (using the data-pricing attribute),
   * and then updates its visibility and displayed price:
   *
   * - If the price is greater than 0, it adds the "visible" class to the element
   *   and updates its value using neviosCheckout__returnFormatMoney(price).
   * - If the price is 0 (or not greater than 0), it removes the "visible" class so
   *   that the line remains hidden.
   *
   * Example usage:
   *   neviosCheckout__updatePricing("subtotal", 299900)
   *
   * @param {string} type - The pricing type (e.g., "subtotal", "discount", "shipping", "payment", "total").
   * @param {number} price - The price value in minor units (e.g., 299900 for 2999.00).
   */
  window.neviosCheckout__updatePricing = function(type, price, label, compareAtPrice) {
    // Update desktop pricing
    var el = document.querySelector('.nch_pricing_line[data-pricing="' + type + '"]');
    // Update mobile pricing
    var elMobile = document.querySelector('.nch_pricing_line[data-pricing-mobile="' + type + '"]');
    var freeShippingLabel = window.neviosCheckout__freeShippingLabel || 'ZDARMA';
    
    // Normalize price to number (handle null/undefined)
    var priceValue = (price === null || price === undefined) ? 0 : Number(price);
    var compareAtValue = (compareAtPrice === null || compareAtPrice === undefined) ? 0 : Number(compareAtPrice);
    
    // Store compare_at for shipping when it's provided (for free shipping persistence)
    if (type === 'shipping' && compareAtValue > 0) {
      window.neviosCheckout__shippingCompareAt = compareAtValue;
    }
    
    // If shipping price is 0 but no compare_at was passed, try to use stored value
    if (type === 'shipping' && priceValue === 0 && compareAtValue === 0 && window.neviosCheckout__shippingCompareAt) {
      compareAtValue = window.neviosCheckout__shippingCompareAt;
    }
    
    [el, elMobile].forEach(function(elem) {
      if (!elem) return;
      
      // if it's the discount row and a label was provided, inject it
      if (type === 'discount' && label) {
        var titleSpan = elem.querySelector('.nch_pricing_line_discount_title');
        if (titleSpan) titleSpan.textContent = label;
      }
    
      // Handle free shipping case (price is 0 but compare_at_price exists)
      if (type === 'shipping' && priceValue === 0 && compareAtValue > 0) {
        elem.classList.add('visible');
        var valEl = elem.querySelector('.nch_pricing_line_value');
        if (valEl) {
          valEl.innerHTML = '<span class="nch_pricing_compare_at">' + 
            window.neviosCheckout__returnFormatMoney(compareAtValue) + 
            '</span><span class="nch_pricing_free">' + freeShippingLabel + '</span>';
        }
      } else if (priceValue > 0) {
        elem.classList.add('visible');
        var formatted = window.neviosCheckout__returnFormatMoney(priceValue);
    
        // for discounts, prefix a minus
        if (type === 'discount') {
          formatted = '-' + formatted;
        }
    
        var valEl = elem.querySelector('.nch_pricing_line_value');
        if (valEl) {
          valEl.innerHTML = formatted;
        }
      } else {
        // Price is 0 and no compare_at - hide the row
        elem.classList.remove('visible');
      }
    });
    
    // Update the mobile accordion header total
    if (type === 'total' && price > 0) {
      var totalDisplay = document.querySelector('[data-pricing-total-display]');
      if (totalDisplay) {
        totalDisplay.innerHTML = window.neviosCheckout__returnFormatMoney(price);
      }
    }
  };
  
  
  /**
   * Update all pricing lines on the DOM based on the provided pricing data.
   *
   * This function loops through each key in the pricing data object and uses the key (which always matches
   * the DOM element's data-pricing attribute) to update the pricing line. It calls the existing
   * neviosCheckout__updatePricing function with the pricing type and the "total" value.
   *
   * Example usage:
   *   neviosCheckout__updateAllPricing(pricingData);
   *
   * @param {Object} pricingData - The pricing data object from the server.
   */
  window.neviosCheckout__updateAllPricing = function(pricingData) {
    if (!pricingData) return;
    Object.keys(pricingData).forEach(function(type) {
      var priceObj = pricingData[type];
      var total = priceObj.total;
      var compareAtTotal = priceObj.compare_at_total || null;
      // updatePricing now handles both desktop and mobile, and compare_at for free shipping
      window.neviosCheckout__updatePricing(type, total, null, compareAtTotal);
    });
  };
  
  /***********************************************************************
                                Discount
  ***********************************************************************/
  
  /**
   * Initialize discount code application.
   * Get error message for discount error code
   */
  window.neviosCheckout__getDiscountErrorMessage = function(errorCode) {
    var errors = window.neviosCheckout__discountErrors || {};
    return errors[errorCode] || errors.DEFAULT || 'Slevový kód nelze použít';
  };

  /**
   * Show discount error message
   */
  window.neviosCheckout__showDiscountError = function(errorCode, inputElement) {
    var message = window.neviosCheckout__getDiscountErrorMessage(errorCode);
    
    // Find the error container (relative to the input)
    var discountBlock = inputElement.closest('discount-block');
    var errorContainer = discountBlock ? discountBlock.querySelector('.nch_discount_error') : null;
    
    if (errorContainer) {
      errorContainer.textContent = message;
      errorContainer.classList.add('visible');
    }
    
    // Set input to error state
    if (inputElement) {
      inputElement.setAttribute('state', 'error');
    }
  };

  /**
   * Clear discount error message
   */
  window.neviosCheckout__clearDiscountError = function(inputElement) {
    var discountBlock = inputElement.closest('discount-block');
    var errorContainer = discountBlock ? discountBlock.querySelector('.nch_discount_error') : null;
    
    if (errorContainer) {
      errorContainer.textContent = '';
      errorContainer.classList.remove('visible');
    }
    
    if (inputElement) {
      inputElement.removeAttribute('state');
    }
  };

  /**
   * Apply discount code - central function used by both desktop and mobile
   */
  window.neviosCheckout__applyDiscount = function(code, inputElement) {
    if (!code) return;
    
    // Clear any previous error
    if (inputElement) {
      window.neviosCheckout__clearDiscountError(inputElement);
    }
    
    // Show loading on all discount buttons
    neviosCheckout__addClass(".nch_discount_button_ready", "nch_displayhidden");
    neviosCheckout__addClass("#discount_code_button", "disabled");
    neviosCheckout__addClass("#discount_code_button_mobile", "disabled");
    neviosCheckout__removeClass(".nch_discount_button_loading", "nch_displayhidden");

    var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) {
      console.error("Checkout ID not found in cookie.");
      window.neviosCheckout__restoreDiscountButtons();
      return;
    }

    fetch(`/a/api/storefront/checkout/discount/${checkoutId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount_code: code })
    })
    .then(res => res.json())
    .then(response => {
      if (response.success && response.data && response.data.pricing) {
        // update pricing and shipping
        window._neviosLastDiscountCode = response.discount.code;
        window.neviosCheckout__updateAllPricing(response.data.pricing);
        if (response.shipping_methods) {
          window.neviosCheckout__renderShippingOptions(response.shipping_methods);
        }

        // Append discount chip to all discount lists
        var discountLists = document.querySelectorAll(".nch_discount_list");
        discountLists.forEach(function(discountList) {
          var chip = document.createElement("span");
          chip.className = "nch_discount_chip fade-in";
          chip.innerHTML = `
            <span class="nch_discount_chip_icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.3333 7.48217V4.01536C13.3333 3.27032 12.725 2.66634 11.9746 2.66634H9.12056C8.77229 2.66634 8.43731 2.79914 8.18482 3.03732L3.30089 7.6443C2.47006 8.42801 2.45316 9.73761 3.26348 10.5422L5.47723 12.7403C6.25792 13.5155 7.51832 13.5324 8.31982 12.7785L12.909 8.4615C13.1798 8.20674 13.3333 7.85261 13.3333 7.48217ZM10.3333 4.66634C9.78097 4.66634 9.33325 5.11405 9.33325 5.66634C9.33325 6.21862 9.78097 6.66634 10.3333 6.66634C10.8855 6.66634 11.3333 6.21862 11.3333 5.66634C11.3333 5.11405 10.8855 4.66634 10.3333 4.66634Z"
                  fill="currentColor"/>
              </svg>
            </span>
            <span class="nch_discount_chip_label">${response.discount.code}</span>
            <span class="nch_discount_chip_remove">
              <svg style="height:16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.92871 4.92896L19.0708 19.0711" stroke="currentColor" stroke-width="1"/>
                <path d="M19.0713 4.92895L4.92915 19.0711" stroke="currentColor" stroke-width="1"/>
              </svg>
            </span>`;
          discountList.appendChild(chip);

          chip.addEventListener("animationend", function() {
            chip.classList.remove("fade-in");
          }, { once: true });

          chip.querySelector(".nch_discount_chip_remove")
            .addEventListener("click", function() {
              window.neviosCheckout__removeDiscount();
            });
        });

        // Clear input values
        var inputs = document.querySelectorAll('#discount_code_input, #discount_code_input_mobile');
        inputs.forEach(function(inp) { inp.value = ''; });
        
      } else {
        // Show error
        var errorCode = response.error_code || 'DEFAULT';
        if (inputElement) {
          window.neviosCheckout__showDiscountError(errorCode, inputElement);
        }
        console.error("Failed to apply discount:", response);
      }
    })
    .catch(err => {
      console.error("Error applying discount:", err);
      if (inputElement) {
        window.neviosCheckout__showDiscountError('DEFAULT', inputElement);
      }
    })
    .finally(() => {
      window.neviosCheckout__restoreDiscountButtons();
    });
  };

  /**
   * Remove discount code
   */
  window.neviosCheckout__removeDiscount = function() {
    var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) return;

    // Fade out and remove all chips
    var allChips = document.querySelectorAll(".nch_discount_chip");
    allChips.forEach(function(c) {
      c.classList.add("fade-out");
      c.addEventListener("animationend", function() {
        c.remove();
      }, { once: true });
    });

    fetch(`/a/api/storefront/checkout/discount/${checkoutId}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" }
    })
    .then(res => res.json())
    .then(removeResp => {
      if (removeResp.success && removeResp.data && removeResp.data.pricing) {
        window.neviosCheckout__updateAllPricing(removeResp.data.pricing);
        if (removeResp.shipping_methods) {
          window.neviosCheckout__renderShippingOptions(removeResp.shipping_methods);
        }
      } else {
        console.error("Failed to remove discount:", removeResp);
      }
    })
    .catch(err => console.error("Error removing discount:", err));
  };

  /**
   * Restore discount buttons to ready state
   */
  window.neviosCheckout__restoreDiscountButtons = function() {
    neviosCheckout__removeClass(".nch_discount_button_ready", "nch_displayhidden");
    neviosCheckout__removeClass("#discount_code_button", "disabled");
    neviosCheckout__removeClass("#discount_code_button_mobile", "disabled");
    neviosCheckout__addClass(".nch_discount_button_loading", "nch_displayhidden");
  };

  /**
   * Initialize discount functionality for desktop input
   * Button is disabled by default and only enabled when user types in the input.
   */
  window.neviosCheckout__initDiscount = function() {
    var input = document.getElementById("discount_code_input");
    var button = document.getElementById("discount_code_button");
    if (!input || !button) return;

    // Disable button by default
    button.classList.add("disabled");
    button.disabled = true;

    // Enable/disable button based on input value and clear errors on input
    input.addEventListener("input", function() {
      window.neviosCheckout__clearDiscountError(input);
      
      if (input.value.trim().length > 0) {
        button.classList.remove("disabled");
        button.disabled = false;
      } else {
        button.classList.add("disabled");
        button.disabled = true;
      }
    });

    button.addEventListener("click", function() {
      var code = input.value.trim();
      if (code) {
        window.neviosCheckout__applyDiscount(code, input);
      }
    });

    // Allow Enter key to submit
    input.addEventListener("keypress", function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var code = input.value.trim();
        if (code) {
          window.neviosCheckout__applyDiscount(code, input);
        }
      }
    });
  };
  
  
  /***********************************************************************
                                  Tip
  ***********************************************************************/

  /**
   * Send tip amount to checkout API and update pricing.
   * @param {number} amountCZK - Tip amount in CZK (e.g. 20). Pass 0 to remove tip.
   */
  window.neviosCheckout__sendTip = function(amountCZK) {
    var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) return;

    var amountCents = Math.round(amountCZK * 100);

    console.log('[TIP] Sending tip:', amountCents, 'cents to checkout:', checkoutId);

    fetch(`/a/api/storefront/checkout/update/${checkoutId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tip: amountCents })
    })
    .then(function(res) { return res.json(); })
    .then(function(resp) {
      console.log('[TIP] Update response:', resp);
      // Try to get pricing from update response first
      var pricing = (resp.data && resp.data.pricing) || resp.pricing;
      if (pricing) {
        window.neviosCheckout__updateAllPricing(pricing);
        return;
      }
      // If update doesn't return pricing, retrieve checkout to get fresh pricing
      console.log('[TIP] No pricing in update response, retrieving checkout...');
      return fetch(`/a/api/storefront/checkout/retrieve/${checkoutId}`)
        .then(function(res) { return res.json(); })
        .then(function(retrieveResp) {
          console.log('[TIP] Retrieve response:', retrieveResp);
          if (retrieveResp.success && retrieveResp.data) {
            var p = retrieveResp.data.pricing || (retrieveResp.data.checkout && retrieveResp.data.checkout.pricing);
            if (p) {
              window.neviosCheckout__updateAllPricing(p);
            }
          }
        });
    })
    .catch(function(err) { console.error("Tip error:", err); });
  };

  /**
   * Initialize tip functionality.
   * Handles preset buttons and custom amount input.
   */
  window.neviosCheckout__initTip = function() {
    var tipBlocks = document.querySelectorAll('[data-tip-block]');
    if (!tipBlocks.length) return;

    window.neviosCheckout__currentTip = 0;

    tipBlocks.forEach(function(block) {
      // Preset amount buttons
      var presetBtns = block.querySelectorAll('[data-tip-amount]');
      var customBtn = block.querySelector('[data-tip-custom]');
      var customInputWrap = block.querySelector('[data-tip-custom-input]');
      var customInput = block.querySelector('[data-tip-custom-value]');
      var customConfirm = block.querySelector('[data-tip-custom-confirm]');

      presetBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var amount = parseInt(btn.getAttribute('data-tip-amount'), 10);

          // Toggle: if already active, deselect (remove tip)
          if (btn.classList.contains('active')) {
            neviosCheckout__clearTipActive();
            window.neviosCheckout__currentTip = 0;
            window.neviosCheckout__sendTip(0);
            return;
          }

          neviosCheckout__clearTipActive();
          btn.classList.add('active');
          // Also activate same amount in the other tip block (desktop/mobile sync)
          document.querySelectorAll('[data-tip-amount="' + amount + '"]').forEach(function(b) {
            b.classList.add('active');
          });

          if (customInputWrap) customInputWrap.style.display = 'none';
          window.neviosCheckout__currentTip = amount;
          window.neviosCheckout__sendTip(amount);
        });
      });

      // Custom button
      if (customBtn && customInputWrap) {
        customBtn.addEventListener('click', function() {
          neviosCheckout__clearTipActive();
          customBtn.classList.add('active');
          // Sync custom btn active state across blocks
          document.querySelectorAll('[data-tip-custom]').forEach(function(b) {
            b.classList.add('active');
          });
          // Show all custom inputs
          document.querySelectorAll('[data-tip-custom-input]').forEach(function(w) {
            w.style.display = 'flex';
          });
          if (customInput) customInput.focus();
        });
      }

      // Custom confirm
      if (customConfirm && customInput) {
        customConfirm.addEventListener('click', function() {
          var val = parseInt(customInput.value, 10);
          if (val > 0) {
            window.neviosCheckout__currentTip = val;
            window.neviosCheckout__sendTip(val);
            // Sync value to other custom inputs
            document.querySelectorAll('[data-tip-custom-value]').forEach(function(inp) {
              inp.value = val;
            });
          }
        });

        customInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            customConfirm.click();
          }
        });
      }
    });
  };

  /**
   * Clear active state from all tip buttons across all tip blocks
   */
  function neviosCheckout__clearTipActive() {
    document.querySelectorAll('.nch_tip_btn').forEach(function(b) {
      b.classList.remove('active');
    });
    document.querySelectorAll('[data-tip-custom-input]').forEach(function(w) {
      w.style.display = 'none';
    });
  }

  /***********************************************************************
                            Shipping & Payment
  ***********************************************************************/
  
  window.neviosCheckout__showPaymentSkeletons = function() {
    var container = document.querySelector('.nch_payment_container');
    if (!container) return;
    container.innerHTML = '';
    var skeletonHTML = `
      <div class="nch_payment_placeholder">
        <div class="nch_payment_option_content">
          <div class="nch_payment_skeleton-circle"></div>
          <div class="nch_payment_skeleton-lines">
            <div class="nch_payment_skeleton-line nch_payment_skeleton-long"></div>
            <div class="nch_payment_skeleton-line nch_payment_skeleton-short"></div>
          </div>
        </div>
      </div>`;
    for (var i = 0; i < 2; i++) {
      container.insertAdjacentHTML('beforeend', skeletonHTML);
    }
    // prepare for fade-in
    container.classList.remove('fade-in');
  };
  
  window.neviosCheckout__renderShippingOptions = function(shippingMethods, preserveSelection) {
    var container = document.querySelector('.nch_shipping_container');
    if (!container) return;
  
    // Store currently selected shipping method ID before re-rendering
    var previouslySelectedId = null;
    var previouslySelectedRadio = document.querySelector('input[name="shipping"]:checked');
    if (previouslySelectedRadio) {
      previouslySelectedId = previouslySelectedRadio.value;
    }
  
    // 1) Show skeleton placeholders
    container.innerHTML = '';
    var skeletonHTML = `
      <div class="nch_shipping_placeholder">
        <div class="nch_shipping_option_content">
          <div class="nch_shipping_skeleton-circle"></div>
          <div class="nch_shipping_skeleton-lines">
            <div class="nch_shipping_skeleton-line nch_shipping_skeleton-long"></div>
            <div class="nch_shipping_skeleton-line nch_shipping_skeleton-short"></div>
          </div>
        </div>
      </div>`;
    for (var i = 0; i < 2; i++) {
      container.insertAdjacentHTML('beforeend', skeletonHTML);
    }
    container.classList.remove('fade-in');
  
    // 2) After a short delay, clear skeletons and fade-in real options
    setTimeout(function() {
      container.innerHTML = '';
  
      if (!shippingMethods || shippingMethods.length === 0) {
        // Empty placeholder
        var emptyHTML = `
          <div class="nch_shipping_placeholder empty">
            <div class="nch_shipping_option_content">
              <span class="nch_shipping_option_empty">
                Please select country of delivery.
              </span>
            </div>
          </div>`;
        container.insertAdjacentHTML('beforeend', emptyHTML);
      } else {
        // Separate STORE methods from HOME/POINT methods
        var regularMethods = shippingMethods.filter(function(m) { 
          return m.shipping_type !== 'STORE'; 
        });
        var storeMethods = shippingMethods.filter(function(m) { 
          return m.shipping_type === 'STORE'; 
        });
  
        // Render regular methods (HOME + POINT) in expandable section - EXPANDED by default
        if (regularMethods.length > 0) {
          var regularSection = document.createElement('div');
          regularSection.className = 'nch_shipping_section';
  
          // Create expandable header
          var regularHeader = document.createElement('div');
          regularHeader.className = 'nch_shipping_section_header expanded';
          regularHeader.innerHTML = `
            <div class="nch_shipping_section_header_content">
              <img src="https://cdn.shopify.com/s/files/1/0870/6621/4730/files/truck-speed-svgrepo-com.svg?v=1770896797" alt="Doručení" class="nch_shipping_section_icon">
              <span class="nch_shipping_section_title">Kurýrem</span>
              <span class="nch_shipping_section_count">(${regularMethods.length} ${regularMethods.length === 1 ? 'možnost' : 'možnosti'})</span>
            </div>
            <svg class="nch_shipping_section_arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
  
          // Create collapsible content - NOT collapsed by default
          var regularContent = document.createElement('div');
          regularContent.className = 'nch_shipping_section_content';
  
          regularMethods.forEach(function(method) {
            regularContent.appendChild(neviosCheckout__createShippingOption(method));
          });
  
          // Toggle functionality
          regularHeader.addEventListener('click', function() {
            regularContent.classList.toggle('collapsed');
            regularHeader.classList.toggle('expanded');
          });
  
          regularSection.appendChild(regularHeader);
          regularSection.appendChild(regularContent);
          container.appendChild(regularSection);
        }
  
        // Render store methods in expandable section - COLLAPSED by default
        if (storeMethods.length > 0) {
          var storeSection = document.createElement('div');
          storeSection.className = 'nch_shipping_section';
  
          // Create expandable header
          var storeHeader = document.createElement('div');
          storeHeader.className = 'nch_shipping_section_header';
          storeHeader.innerHTML = `
            <div class="nch_shipping_section_header_content">
              <img src="https://cdn.shopify.com/s/files/1/0870/6621/4730/files/store-2-svgrepo-com.svg?v=1770896797" alt="Osobní odběr" class="nch_shipping_section_icon">
              <span class="nch_shipping_section_title">Osobní odběr v prodejně</span>
              <span class="nch_shipping_section_count">(${storeMethods.length} ${storeMethods.length === 1 ? 'prodejna' : 'prodejny'})</span>
            </div>
            <svg class="nch_shipping_section_arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
  
          // Create collapsible content - collapsed by default
          var storeContent = document.createElement('div');
          storeContent.className = 'nch_shipping_section_content collapsed';
  
          storeMethods.forEach(function(method) {
            storeContent.appendChild(neviosCheckout__createShippingOption(method));
          });
  
          // Toggle functionality
          storeHeader.addEventListener('click', function() {
            storeContent.classList.toggle('collapsed');
            storeHeader.classList.toggle('expanded');
          });
  
          storeSection.appendChild(storeHeader);
          storeSection.appendChild(storeContent);
          container.appendChild(storeSection);
        }
  
        window.neviosCheckout__initShippingOptions();
        
        // Restore previously selected shipping method if it still exists
        if (previouslySelectedId) {
          var radioToRestore = document.querySelector('input[name="shipping"][value="' + previouslySelectedId + '"]');
          if (radioToRestore) {
            radioToRestore.checked = true;
            var labelToRestore = radioToRestore.closest('.nch_shipping_option');
            if (labelToRestore) {
              labelToRestore.classList.add('nch_shipping_selected');
            }
            
            // Also ensure the section containing this option is expanded
            var sectionContent = radioToRestore.closest('.nch_shipping_section_content');
            var sectionHeader = sectionContent ? sectionContent.previousElementSibling : null;
            if (sectionContent && sectionContent.classList.contains('collapsed')) {
              sectionContent.classList.remove('collapsed');
              if (sectionHeader) sectionHeader.classList.add('expanded');
            }
            
            // Show/hide the "different shipping" checkbox based on shipping type
            var shippingType = radioToRestore.getAttribute('shipping-type');
            if (shippingType === 'HOME') {
              neviosCheckout__addClass(".nch_different_shipping_checkbox", "visible");
            } else {
              neviosCheckout__removeClass(".nch_different_shipping_checkbox", "visible");
            }
          }
        }
      }
      // fade in content
      container.classList.add('fade-in');
    }, 350);
  };
  
  /**
   * Widget registry — maps widget identifiers (from API) to render functions.
   * Each function receives the shipping method object and returns an HTML string.
   */
  window.neviosCheckout__widgets = {};

  /**
   * Shared render function for all pickup-point widgets.
   * Reads button text and logo from neviosCheckout__widgetSettings.
   */
  window.neviosCheckout__renderWidgetHTML = function(carrier) {
    var settings = (window.neviosCheckout__widgetSettings || {})[carrier] || {};
    var btnText = settings.btnText || 'Vybrat pobočku';
    var logoHtml = settings.logo ? '<img src="' + settings.logo + '" alt="" />' : '';
    return '<div class="nch_widget nch_widget--' + carrier + '">' +
      '<button type="button" class="nch_widget_btn n_global-element_box-shadow" onclick="neviosCheckout__widgets[' + "'" + carrier + "'" + '].pick(this)">' +
        '<span class="nch_widget_btn_text">' + btnText + '</span>' +
        logoHtml +
      '</button>' +
      '<div class="nch_widget_status nch_widget_status--empty">' +
        '<div class="nch_widget_status_text">' +
          '<span class="nch_widget_placeholder">Prosím vyberte výdejní místo</span>' +
          '<span class="nch_widget_point_name" style="display:none"></span>' +
          '<span class="nch_widget_point_detail" style="display:none"></span>' +
        '</div>' +
        '<svg class="nch_widget_icon_alert" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>' +
        '<svg class="nch_widget_icon_ok" style="display:none" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>' +
      '</div>' +
    '</div>';
  };

  /**
   * Shared helper to store point data and update widget status UI.
   */
  window.neviosCheckout__storePointData = function(widgetContainer, pointId, pointName, pointAddress, pointCity, pointZip) {
    var existing = widgetContainer.querySelector('.nch_widget_point_data');
    if (existing) existing.remove();

    var dataDiv = document.createElement('div');
    dataDiv.className = 'nch_widget_point_data';
    dataDiv.style.display = 'none';
    dataDiv.innerHTML =
      '<input type="hidden" data-point-id value="' + pointId + '">' +
      '<input type="hidden" data-point-name value="' + pointName + '">' +
      '<input type="hidden" data-point-address value="' + pointAddress + '">' +
      '<input type="hidden" data-point-city value="' + pointCity + '">' +
      '<input type="hidden" data-point-zip value="' + pointZip + '">';
    widgetContainer.appendChild(dataDiv);

    var status = widgetContainer.querySelector('.nch_widget_status');
    if (status) {
      status.classList.remove('nch_widget_status--empty');
      status.classList.add('nch_widget_status--selected');
      var placeholder = status.querySelector('.nch_widget_placeholder');
      var nameEl = status.querySelector('.nch_widget_point_name');
      var detailEl = status.querySelector('.nch_widget_point_detail');
      var alertIcon = status.querySelector('.nch_widget_icon_alert');
      var okIcon = status.querySelector('.nch_widget_icon_ok');
      if (placeholder) placeholder.style.display = 'none';
      if (nameEl) { nameEl.textContent = pointName; nameEl.style.display = ''; }
      if (detailEl) {
        var detail = [pointAddress, pointZip, pointCity].filter(Boolean).join(', ');
        detailEl.textContent = detail;
        detailEl.style.display = detail ? '' : 'none';
      }
      if (alertIcon) alertIcon.style.display = 'none';
      if (okIcon) okIcon.style.display = '';
    }
  };

  // ──────────────────────────────────────────────
  // Zásilkovna (Packeta) widget
  // ──────────────────────────────────────────────

  neviosCheckout__widgets.zasilkovna = function(method) {
    return window.neviosCheckout__renderWidgetHTML('zasilkovna');
  };

  /**
   * Zásilkovna (Packeta) widget — pick() opens the Packeta iframe picker.
   */
  neviosCheckout__widgets.zasilkovna.pick = function(btnElement) {
    var widgetContainer = btnElement.closest('.nch_shipping_option_widget');
    var Packeta = window.__neviosPacketa || {};
    window.__neviosPacketa = Packeta;
    Packeta.close = function() {};

    var url = 'https://widget.packeta.com/v6/#/?&version=3&loader=library&referrer=' + encodeURIComponent(window.location.origin);

    var overlay = document.createElement('div');
    overlay.style.cssText = 'z-index:999999;position:fixed;left:0;top:0;width:100%;height:100%;background:rgba(0,0,0,0.3);';
    overlay.addEventListener('click', function() { Packeta.close(); });

    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'border:hidden;position:absolute;left:0;top:0;width:100%;height:100%;padding:10px 5px;box-sizing:border-box;';
    iframe.setAttribute('allow', 'geolocation');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('src', url);
    overlay.appendChild(iframe);
    document.body.appendChild(overlay);

    var receiver = function(e) {
      try {
        var message = typeof e.data === 'object' ? e.data : JSON.parse(e.data);
        if (!message.packetaWidgetMessage) return;
      } catch (err) { return; }
      if (!message.packetaPoint || !message.packetaPoint.id) return;

      var point = message.packetaPoint;
      window.neviosCheckout__storePointData(widgetContainer, point.id, point.name || '', point.street || '', point.city || '', point.zip || '');
      Packeta.close();
    };
    window.addEventListener('message', receiver);

    Packeta.close = function() {
      window.removeEventListener('message', receiver);
      if (overlay.parentNode) document.body.removeChild(overlay);
      Packeta.close = function() {};
    };

    var escHandler = function(e) {
      if (e.key === 'Escape') { Packeta.close(); document.removeEventListener('keyup', escHandler); }
    };
    document.addEventListener('keyup', escHandler);
  };

  // ──────────────────────────────────────────────
  // Balíkovna (Česká pošta) widget
  // ──────────────────────────────────────────────

  neviosCheckout__widgets.balikovna = function(method) {
    return window.neviosCheckout__renderWidgetHTML('balikovna');
  };

  neviosCheckout__widgets.balikovna.pick = function(btnElement) {
    var widgetContainer = btnElement.closest('.nch_shipping_option_widget');

    var overlay = document.createElement('div');
    overlay.style.cssText = 'z-index:999999;position:fixed;left:0;top:0;width:100%;height:100%;background:rgba(0,0,0,0.3);';

    var closeBar = document.createElement('div');
    closeBar.style.cssText = 'position:absolute;top:10px;right:15px;z-index:10;width:28px;height:28px;cursor:pointer;color:#fff;';
    closeBar.innerHTML = '<svg viewBox="0 0 24 24" fill="none" width="28" height="28"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6 6 18M6 6l12 12"/></svg>';
    overlay.appendChild(closeBar);

    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'border:hidden;position:absolute;left:0;top:0;width:100%;height:100%;padding:10px 5px;box-sizing:border-box;';
    iframe.setAttribute('allow', 'geolocation');
    iframe.setAttribute('src', 'https://b2c.cpost.cz/locations/?type=BALIKOVNY');
    overlay.appendChild(iframe);
    document.body.appendChild(overlay);

    var close = function() {
      window.removeEventListener('message', receiver);
      document.removeEventListener('keyup', escHandler);
      if (overlay.parentNode) document.body.removeChild(overlay);
    };

    closeBar.addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });

    var receiver = function(e) {
      var data = e.data;
      if (!data || data.message !== 'pickerResult' || !data.point) return;
      console.log('[Balikovna] Selected point:', data.point);

      var pointId = String(data.point.id || '');
      if (pointId.charAt(0) === 'B') pointId = pointId.substring(1);

      window.neviosCheckout__storePointData(
        widgetContainer,
        pointId,
        data.point.name || '',
        data.point.address || data.point.street || '',
        data.point.city || '',
        data.point.zip || data.point.zipCode || data.point.postcode || ''
      );
      close();
    };
    window.addEventListener('message', receiver);

    var escHandler = function(e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keyup', escHandler);
  };

  // ──────────────────────────────────────────────
  // GLS ParcelShop widget
  // ──────────────────────────────────────────────

  neviosCheckout__widgets.gls = function(method) {
    return window.neviosCheckout__renderWidgetHTML('gls');
  };

  neviosCheckout__widgets.gls.pick = function(btnElement) {
    var widgetContainer = btnElement.closest('.nch_shipping_option_widget');

    var overlay = document.createElement('div');
    overlay.style.cssText = 'z-index:999999;position:fixed;left:0;top:0;width:100%;height:100%;background:rgba(0,0,0,0.3);';

    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'border:hidden;position:absolute;left:0;top:0;width:100%;height:100%;padding:10px 5px;box-sizing:border-box;';
    iframe.setAttribute('src', 'https://maps.gls-czech.cz/?find=1');
    overlay.appendChild(iframe);
    document.body.appendChild(overlay);

    var close = function() {
      window.removeEventListener('message', receiver);
      document.removeEventListener('keyup', escHandler);
      if (overlay.parentNode) document.body.removeChild(overlay);
    };

    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });

    var receiver = function(e) {
      var data = e.data;
      if (!data || !data.parcelshop) return;
      var detail = data.parcelshop.detail || data.parcelshop;
      console.log('[GLS] Selected parcelshop:', data.parcelshop);

      var pointId = detail.pclshopid || detail.id || '';
      if (!pointId) return;

      window.neviosCheckout__storePointData(
        widgetContainer,
        pointId,
        detail.name || '',
        detail.address || detail.street || '',
        detail.city || '',
        detail.zipcode || detail.zip || ''
      );
      close();
    };
    window.addEventListener('message', receiver);

    var escHandler = function(e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keyup', escHandler);
  };

  // ──────────────────────────────────────────────
  // PPL shared pick logic
  // ──────────────────────────────────────────────

  function neviosCheckout__pplPick(btnElement, hiddenPoints) {
    var widgetContainer = btnElement.closest('.nch_shipping_option_widget');

    var overlay = document.createElement('div');
    overlay.style.cssText = 'z-index:999999;position:fixed;left:0;top:0;width:100%;height:100%;background:rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;';

    var mapWrapper = document.createElement('div');
    mapWrapper.style.cssText = 'width:90%;height:90%;max-width:1200px;background:#fff;border-radius:12px;overflow:hidden;position:relative;';

    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'position:absolute;top:10px;right:15px;z-index:10;background:none;border:none;font-size:28px;cursor:pointer;color:#333;line-height:1;';
    mapWrapper.appendChild(closeBtn);

    var mapDiv = document.createElement('div');
    mapDiv.id = 'ppl-parcelshop-map';
    mapDiv.setAttribute('data-country', 'cz');
    mapDiv.setAttribute('data-countries', 'cz');
    mapDiv.setAttribute('data-language', 'cs');
    mapDiv.setAttribute('data-mode', 'default');
    if (hiddenPoints) mapDiv.setAttribute('data-hiddenpoints', hiddenPoints);
    mapDiv.style.cssText = 'width:100%;height:100%;';
    mapWrapper.appendChild(mapDiv);

    overlay.appendChild(mapWrapper);
    document.body.appendChild(overlay);

    var close = function() {
      document.removeEventListener('ppl-parcelshop-map', pplHandler);
      document.removeEventListener('keyup', escHandler);
      if (overlay.parentNode) document.body.removeChild(overlay);
      var pplScript = document.querySelector('script[src*="ppl.cz/sources/map/main.js"]');
      if (pplScript) pplScript.remove();
      var pplCss = document.querySelector('link[href*="ppl.cz/sources/map/main.css"]');
      if (pplCss) pplCss.remove();
    };

    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
    closeBtn.addEventListener('click', close);

    var pplHandler = function(e) {
      var point = e.detail;
      console.log('[PPL] Selected parcelshop:', point);
      if (!point) return;

      var pointId = point.code || point.id || point.accessPointId || '';
      var pointName = point.name || point.title || '';
      if (!pointId && !pointName) return;

      window.neviosCheckout__storePointData(
        widgetContainer,
        pointId,
        pointName,
        point.address || point.street || '',
        point.city || '',
        point.zipCode || point.zip || point.postcode || ''
      );
      close();
    };
    document.addEventListener('ppl-parcelshop-map', pplHandler);

    var escHandler = function(e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keyup', escHandler);

    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://ppl.cz/sources/map/main.css';
    document.head.appendChild(css);

    var script = document.createElement('script');
    script.src = 'https://ppl.cz/sources/map/main.js';
    script.async = true;
    document.head.appendChild(script);
  }

  // ──────────────────────────────────────────────
  // PPL ParcelShop Smart (all point types)
  // ──────────────────────────────────────────────

  neviosCheckout__widgets['ppl-point-smart'] = function(method) {
    return window.neviosCheckout__renderWidgetHTML('ppl-point-smart');
  };

  neviosCheckout__widgets['ppl-point-smart'].pick = function(btnElement) {
    neviosCheckout__pplPick(btnElement, null);
  };

  // ──────────────────────────────────────────────
  // PPL Smart Box (AlzaBox + ParcelShop hidden)
  // ──────────────────────────────────────────────

  neviosCheckout__widgets['ppl-smart-box'] = function(method) {
    return window.neviosCheckout__renderWidgetHTML('ppl-smart-box');
  };

  neviosCheckout__widgets['ppl-smart-box'].pick = function(btnElement) {
    neviosCheckout__pplPick(btnElement, 'ParcelShop, AlzaBox');
  };

  /**
   * Renders widget HTML for a shipping method based on method.widget identifier.
   * Returns empty string if no widget or unknown widget type.
   */
  window.neviosCheckout__renderWidget = function(method) {
    if (!method.widget) return '';
    var widgetFn = window.neviosCheckout__widgets[method.widget];
    if (typeof widgetFn === 'function') {
      return widgetFn(method);
    }
    // Fallback: if widget is raw HTML (legacy), render as-is
    if (method.widget.charAt(0) === '<') {
      return method.widget;
    }
    console.warn('Unknown widget type:', method.widget);
    return '';
  };

  /**
   * Helper function to create a shipping option element
   */
  window.neviosCheckout__createShippingOption = function(method) {
    // build the price container HTML depending on compare_at_price
    var priceContainerHtml;
    var freeShippingLabel = window.neviosCheckout__freeShippingLabel || 'ZDARMA';
    
    if (
      method.compare_at_price != null &&
      method.compare_at_price > method.price
    ) {
      // show original & discounted
      if (method.price === 0) {
        // Free shipping - show strikethrough original + free label
        priceContainerHtml = `
          <span class="nch_shipping_compare_at_price">
            ${window.neviosCheckout__returnFormatMoney(method.compare_at_price)}
          </span>
          <span class="nch_shipping_price free">${freeShippingLabel}</span>`;
      } else {
        // Regular discount
        priceContainerHtml = `
          <span class="nch_shipping_compare_at_price">
            ${window.neviosCheckout__returnFormatMoney(method.compare_at_price)}
          </span>
          <span class="nch_shipping_price discounted">
            ${window.neviosCheckout__returnFormatMoney(method.price)}
          </span>`;
      }
    } else {
      // only show the actual price
      priceContainerHtml = `
        <span class="nch_shipping_price">
          ${window.neviosCheckout__returnFormatMoney(method.price)}
        </span>`;
    }
  
    var label = document.createElement('label');
    label.className = 'nch_shipping_option';
    label.setAttribute('data-key', method.set_id);
  
    var logoHtml = method.logo
      ? `<img src="${method.logo}" alt="" class="nch_shipping_logo" />`
      : '';

    label.innerHTML = `
      <div class="nch_shipping_option_content">
        <input
          type="radio"
          name="shipping"
          class="nch_shipping_radio"
          id="nch_shipping_${method.set_id}"
          value="${method.set_id}"
          shipping-type="${method.shipping_type}"
        />
        <span class="nch_shipping_custom-radio"></span>
        ${logoHtml}
        <div class="nch_shipping_label">
          <div class="nch_shipping_info">
            <span class="nch_shipping_title">${method.name}</span>
            ${method.description ? `<span class="nch_shipping_description">${method.description}</span>` : ''}
          </div>
          <div class="nch_shipping_price-container">
            ${priceContainerHtml}
          </div>
        </div>
      </div>
      <div class="nch_shipping_option_widget">
        ${window.neviosCheckout__renderWidget(method)}
      </div>`;
  
    return label;
  };
  
  window.neviosCheckout__initShippingOptions = function() {
    // 1) Wire up the radio-change behavior
    document.querySelectorAll('.nch_shipping_option').forEach(label => {
      var radio = label.querySelector('.nch_shipping_radio');
      radio.addEventListener('change', function() {
        if (!radio.checked) return;

        // Clear error state on shipping container
        var shippingContainer = document.querySelector('.nch_shipping_container');
        if (shippingContainer) shippingContainer.classList.remove('error');

        // Toggle selected UI
        document.querySelectorAll('.nch_shipping_option').forEach(l => {
          l.classList.toggle('nch_shipping_selected', l === label);
        });

        // Trigger API call
        window.neviosCheckout__selectShipping(radio.value);
  
        // Show/hide the "different shipping" checkbox
        var shippingType = radio.getAttribute('shipping-type');
        if (shippingType === 'HOME') {
          neviosCheckout__addClass(".nch_different_shipping_checkbox", "visible");
        } else {
          neviosCheckout__removeClass(".nch_different_shipping_checkbox", "visible");
          neviosCheckout__removeClass(".nch_different_shipping_block", "visible");
          var differentShipping = document.getElementById("differentShipping");
          differentShipping.checked = false;
          differentShipping.dispatchEvent(new Event("change"));
        }
      });
    });
  
  };
  
  window.neviosCheckout__selectShipping = function(shippingSetId) {
    var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) return console.error("No checkout ID");
  
    // immediately show payment skeletons
    window.neviosCheckout__showPaymentSkeletons();
  
    fetch(`/a/api/storefront/checkout/select-shipping/${checkoutId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ shipping_set_id: shippingSetId })
    })
    .then(res => res.json())
    .then(function(response) {
      if (!response.success) return console.error("Select shipping failed:", response.error);
      window.neviosCheckout__updateAllPricing(response.pricing);
      window.neviosCheckout__renderPaymentMethods(response.payment_methods);
    })
    .catch(err => console.error("Error selecting shipping:", err));
  };
  
  window.neviosCheckout__renderPaymentMethods = function(paymentMethods) {
    var container = document.querySelector('.nch_payment_container');
    if (!container) return;
  
    // clear skeletons and fade-in real content after delay
    setTimeout(function() {
      container.innerHTML = '';
      if (!paymentMethods || paymentMethods.length === 0) {
        var emptyHTML = `
          <div class="nch_payment_placeholder empty">
            <div class="nch_payment_option_content">
              <span class="nch_payment_option_empty">
                Please select payment method.
              </span>
            </div>
          </div>`;
        container.insertAdjacentHTML('beforeend', emptyHTML);
      } else {
        paymentMethods.forEach(function(method) {
          var label = document.createElement('label');
          label.className = 'nch_payment_option';
          label.setAttribute('data-key', method.set_id);
          label.innerHTML = `
            <div class="nch_payment_option_content">
              <input
                type="radio"
                name="payment"
                class="nch_payment_radio"
                id="nch_payment_${method.set_id}"
                value="${method.set_id}"
              />
              <span class="nch_payment_custom-radio"></span>
              <div class="nch_payment_label">
                <span class="nch_payment_title">${method.name}</span>
                <div class="nch_payment_labels">
                  ${method.labels || ''}
                </div>
              </div>
            </div>
            <div class="nch_payment_option_widget">
              ${method.widget || ''}
            </div>`;
          container.appendChild(label);
        });
        window.neviosCheckout__initPaymentOptions();
      }
      container.classList.add('fade-in');
    }, 350);
  };
  
  window.neviosCheckout__selectPayment = function(paymentSetId) {
    var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) {
      console.error("Cannot select payment: no checkout ID found");
      return;
    }
  
    // Optionally disable all payment radios to prevent double-clicks
    document.querySelectorAll('.nch_payment_radio').forEach(function(radio) {
      radio.disabled = true;
    });
  
    fetch(`/a/api/storefront/checkout/select-payment/${checkoutId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ payment_set_id: paymentSetId })
    })
    .then(function(res) { return res.json(); })
    .then(function(response) {
      if (!response.success) {
        console.error("Select payment failed:", response.error);
        return;
      }
      // Update all pricing lines with the new pricing breakdown
      window.neviosCheckout__updateAllPricing(response.pricing);
    })
    .catch(function(err) {
      console.error("Error selecting payment method:", err);
    })
    .finally(function() {
      // Re-enable the radios
      document.querySelectorAll('.nch_payment_radio').forEach(function(radio) {
        radio.disabled = false;
      });
    });
  };
  
  window.neviosCheckout__initPaymentOptions = function() {
    document.querySelectorAll('.nch_payment_option').forEach(label => {
      var radio = label.querySelector('.nch_payment_radio');
      radio.addEventListener('change', function() {
        if (!radio.checked) return;

        // Clear error state on payment container
        var paymentContainer = document.querySelector('.nch_payment_container');
        if (paymentContainer) paymentContainer.classList.remove('error');

        document.querySelectorAll('.nch_payment_option').forEach(l => {
          l.classList.toggle('nch_payment_selected', l === label);
        });
        window.neviosCheckout__selectPayment(radio.value);
      });
    });
  };
  
  /***********************************************************************
                             Order Conversion
  ***********************************************************************/
  
  /**
   * Handle the final order confirmation and conversion.
   * 
   * This function:
   * 1. Validates all required form fields
   * 2. Checks if upsell is enabled - if so, shows upsell overlay first
   * 3. Gathers form data into the correct payload structure
   * 4. Calls the checkout convert API
   * 5. Handles the response and redirects appropriately
   */
  window.neviosCheckout__confirmOrder = function() {
    // 1. Validate required fields and terms
    if (!neviosCheckout__validateForm()) {
      return; // Validation failed, stop here
    }
  
    // 2. Immediately disable buttons and show spinner
    var confirmBtns = document.querySelectorAll('.nch_confirm_btn');
    var originalText = confirmBtns[0] ? confirmBtns[0].textContent : 'Dokončit';
    window.neviosCheckout__originalBtnText = originalText;
    
    confirmBtns.forEach(function(btn) {
      btn.disabled = true;
      btn.classList.add('loading');
      btn.innerHTML = '<span class="nch_btn_spinner"></span>';
    });

    // 3. Check if upsell is enabled and has products
    var upsellEnabled = window.neviosCheckout__upsellEnabled;
    var upsellProducts = window.neviosCheckout__upsellProducts || [];
    var hasUpsellProducts = upsellProducts.filter(function(p) { return p && p.available !== false; }).length > 0;
    
    if (upsellEnabled && hasUpsellProducts) {
      // Show upsell overlay instead of default loading
      setTimeout(function() {
        neviosCheckout__showUpsellOverlay();
      }, 300);
    } else {
      // Proceed directly to conversion (existing flow)
      setTimeout(function() {
        neviosCheckout__showLoadingOverlay();
        neviosCheckout__convertCheckout();
      }, 300);
    }
  };
  
  /**
   * Show upsell overlay with products
   */
  window.neviosCheckout__showUpsellOverlay = function() {
    neviosCheckout__showLoadingOverlay('upsell');
    neviosCheckout__wireUpsellButtons();
    /* Notify analytics that upsell overlay is visible */
    document.dispatchEvent(new CustomEvent('nevios:upsell-overlay-shown'));
  };
  
  /**
   * Wire upsell button events
   */
  window.neviosCheckout__wireUpsellButtons = function() {
    // Skip button -> proceed to conversion
    var skipBtn = document.getElementById('nch_upsell_skip');
    if (skipBtn) {
      skipBtn.addEventListener('click', function() {
        neviosCheckout__showLoadingOverlay('default');
        neviosCheckout__convertCheckout();
      });
    }
    
    // Add buttons from upsell cards -> add item to checkout
    var addBtns = document.querySelectorAll('[data-checkout-upsell-add]');
    addBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find parent upsell card component to get variant ID and custom pricing
        var card = btn.closest('checkout-upsell-card-component');
        if (!card) return;
        
        var variantId = card.dataset.variantId;
        if (!variantId) return;
        
        // Get custom pricing if set
        var customPrice = card.dataset.customPrice || null;
        var customComparePrice = card.dataset.customComparePrice || null;
        
        // Check if already added
        if (btn.dataset.added === 'true') return;
        
        // Disable button and show loading
        btn.disabled = true;
        var addText = btn.querySelector('[data-add-text]');
        var addedState = btn.querySelector('[data-added-state]');
        
        if (addText) {
          addText.innerHTML = '<span class="nch_btn_spinner_small"></span>';
        }
        
        neviosCheckout__addUpsellItem(variantId, 1, customPrice, customComparePrice)
          .then(function(response) {
            if (response.success) {
              // Mark as added
              btn.dataset.added = 'true';
              btn.disabled = false;

              // Analytics — fire upsell AddToCart with product data from DOM
              if (typeof window.n_performance_addToCartUpsell === 'function') {
                try {
                  var variants = JSON.parse(card.dataset.variants || '[]');
                  var v = variants.find(function(vi) { return String(vi.id) === String(card.dataset.variantId); }) || {};
                  var upsellPrice = customPrice ? parseInt(customPrice, 10) / 100 : (v.price || 0) / 100;
                  window.n_performance_addToCartUpsell({
                    sku: v.sku || '',
                    variant_id: card.dataset.variantId || '',
                    title: v.name || v.public_title || '',
                    price: upsellPrice,
                    currency: window.n_p_currency || '',
                    source: 'checkout'
                  });
                } catch(e) {}
              }
            } else {
              // Re-enable button on error
              btn.disabled = false;
              if (addText) {
                var priceDisplay = addText.querySelector('[data-price-display]');
                if (priceDisplay) {
                  addText.innerHTML = '';
                  addText.appendChild(priceDisplay);
                }
              }
              console.error('Failed to add upsell item:', response.error);
            }
          })
          .catch(function(error) {
            // Re-enable button on error
            btn.disabled = false;
            console.error('Error adding upsell item:', error);
          });
      });
    });
  };
  
  /**
   * Add item to checkout via API
   * Endpoint: POST /a/api/storefront/checkout/update/{checkoutId}/add-item
   */
  window.neviosCheckout__addUpsellItem = function(variantId, quantity, customPrice, customCompareAtPrice) {
    var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) {
      return Promise.reject(new Error('No checkout ID found'));
    }
    
    var payload = { 
      variant_eid: parseInt(variantId, 10), 
      quantity: quantity || 1 
    };
    
    // Support custom pricing for upsell offers
    if (customPrice && customPrice !== '') {
      payload.custom_price = parseInt(customPrice, 10);
    }
    if (customCompareAtPrice && customCompareAtPrice !== '') {
      payload.custom_compare_at_price = parseInt(customCompareAtPrice, 10);
    }
    
    return fetch(`/a/api/storefront/checkout/update/${checkoutId}/add-item`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(res) { return res.json(); });
  };
  
  /**
   * Convert checkout to order (extracted from confirmOrder)
   */
  window.neviosCheckout__convertCheckout = function() {
    var confirmBtns = document.querySelectorAll('.nch_confirm_btn');
    var originalText = window.neviosCheckout__originalBtnText || 'Dokončit';
    
    // Gather all form data
    var payload = neviosCheckout__buildPayload();
    
    if (!payload) {
      // Hide loading overlay and restore button state
      neviosCheckout__hideLoadingOverlay();
      confirmBtns.forEach(function(btn) {
        btn.innerHTML = originalText;
        btn.disabled = false;
        btn.classList.remove('loading');
      });
      return;
    }
  
    // Get checkout ID
    var checkoutId = window.neviosCheckout__getCookie("neviosCheckout");
    if (!checkoutId) {
      neviosCheckout__hideLoadingOverlay();
      alert('Chyba: Nenalezen checkout. Obnovte stránku a zkuste znovu.');
      confirmBtns.forEach(function(btn) {
        btn.innerHTML = originalText;
        btn.disabled = false;
        btn.classList.remove('loading');
      });
      return;
    }
  
    console.log('[DEBUG] Converting checkout with payload:', payload);
  
    // Call convert API
    fetch(`/a/api/storefront/checkout/convert/${checkoutId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      if (data.success) {
        console.log('[DEBUG] Checkout converted successfully:', data);
        
        // Handle next step (overlay stays visible during redirect)
        neviosCheckout__handleNextStep(data.data.next_step);
        
      } else {
        console.error('Conversion failed:', data.error);
        neviosCheckout__hideLoadingOverlay();
        alert('Chyba při vytváření objednávky: ' + data.error);
        
        // Restore button state
        confirmBtns.forEach(function(btn) {
          btn.innerHTML = originalText;
          btn.disabled = false;
          btn.classList.remove('loading');
        });
      }
    })
    .catch(function(error) {
      console.error('Error converting checkout:', error);
      neviosCheckout__hideLoadingOverlay();
      alert('Došlo k chybě při zpracování objednávky. Zkuste to znovu.');
      
      // Restore button state
      confirmBtns.forEach(function(btn) {
        btn.innerHTML = originalText;
        btn.disabled = false;
        btn.classList.remove('loading');
      });
    });
  };

  /**
   * Show the loading overlay
   */
  window.neviosCheckout__showLoadingOverlay = function(state) {
    var overlay = document.getElementById('nch_loading_overlay');
    if (overlay) {
      // Hide all states first
      var allStates = overlay.querySelectorAll('.nch_loading_state');
      allStates.forEach(function(s) { s.style.display = 'none'; });
      
      // Show the requested state (default if not specified)
      var targetState = state || 'default';
      var stateEl = overlay.querySelector('[data-state="' + targetState + '"]');
      if (stateEl) {
        stateEl.style.display = 'flex';
        
        // Apply upsell background color if showing upsell state
        if (targetState === 'upsell') {
          var upsellBg = getComputedStyle(stateEl).getPropertyValue('--nch_upsell-background').trim();
          if (upsellBg) {
            overlay.style.setProperty('--nch_loading-background', upsellBg);
          }
        } else {
          // Reset to default loading background
          overlay.style.removeProperty('--nch_loading-background');
        }
      } else {
        // Fallback to default
        var defaultState = overlay.querySelector('[data-state="default"]');
        if (defaultState) defaultState.style.display = 'flex';
        overlay.style.removeProperty('--nch_loading-background');
      }
      
      overlay.classList.add('visible');
      document.body.style.overflow = 'hidden';
    }
  };

  /**
   * Hide the loading overlay
   */
  window.neviosCheckout__hideLoadingOverlay = function() {
    var overlay = document.getElementById('nch_loading_overlay');
    if (overlay) {
      overlay.classList.remove('visible');
      document.body.style.overflow = '';
    }
  };

  /**
   * Show bank transfer info in the overlay
   * @param {Object} bankInfo - Bank transfer info from API
   * @param {string} redirectUrl - URL to redirect after clicking buttons
   */
  window.neviosCheckout__showBankTransferOverlay = function(bankInfo, redirectUrl) {
    var overlay = document.getElementById('nch_loading_overlay');
    if (!overlay) return;
    
    // Populate bank transfer info
    var qrImg = document.getElementById('nch_bank_qr');
    var amountEl = document.getElementById('nch_bank_amount');
    var accountEl = document.getElementById('nch_bank_account');
    var ibanEl = document.getElementById('nch_bank_iban');
    var varSymbolEl = document.getElementById('nch_bank_var_symbol');
    var swiftEl = document.getElementById('nch_bank_swift');
    
    // Copy icon SVG
    var copyIconSvg = '<svg class="nch_copy_icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>';
    var checkIconSvg = '<svg class="nch_copy_icon nch_copy_check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

    // Helper to copy text to clipboard
    function copyToClipboard(text, btn) {
      navigator.clipboard.writeText(text).then(function() {
        btn.innerHTML = checkIconSvg;
        btn.classList.add('copied');
        setTimeout(function() {
          btn.innerHTML = copyIconSvg;
          btn.classList.remove('copied');
        }, 1500);
      }).catch(function(err) {
        console.error('Failed to copy:', err);
      });
    }

    // Helper to show/hide row based on value and add copy button
    function setRowValue(el, value, rawValue) {
      if (!el) return;
      var row = el.closest('.nch_bank_info_row');
      if (value && value !== '-') {
        el.textContent = value;
        
        // Add copy button if not already present
        var wrapper = el.closest('.nch_bank_value_wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'nch_bank_value_wrapper';
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
          
          var copyBtn = document.createElement('button');
          copyBtn.className = 'nch_copy_btn';
          copyBtn.type = 'button';
          copyBtn.innerHTML = copyIconSvg;
          copyBtn.onclick = function() {
            copyToClipboard(rawValue || value, copyBtn);
          };
          wrapper.appendChild(copyBtn);
        } else {
          // Update existing copy button's onclick
          var existingBtn = wrapper.querySelector('.nch_copy_btn');
          if (existingBtn) {
            existingBtn.onclick = function() {
              copyToClipboard(rawValue || value, existingBtn);
            };
          }
        }
        
        if (row) row.style.display = '';
      } else {
        if (row) row.style.display = 'none';
      }
    }

    if (qrImg) {
      var qrContainer = qrImg.closest('.nch_bank_qr_container');
      if (bankInfo.qr_base64) {
        qrImg.src = bankInfo.qr_base64;
        if (qrContainer) qrContainer.style.display = '';
      } else {
        if (qrContainer) qrContainer.style.display = 'none';
      }
    }
    
    // Amount - always show if present (with copy for raw amount)
    if (amountEl && bankInfo.amount) {
      var formattedAmount = window.neviosCheckout__returnFormatMoney(bankInfo.amount * 100);
      setRowValue(amountEl, formattedAmount, bankInfo.amount.toString());
    } else if (amountEl) {
      var amountRow = amountEl.closest('.nch_bank_info_row');
      if (amountRow) amountRow.style.display = 'none';
    }
    
    // Account number
    if (accountEl && bankInfo.account_number && bankInfo.bank_code) {
      setRowValue(accountEl, bankInfo.account_number + '/' + bankInfo.bank_code, bankInfo.account_number + '/' + bankInfo.bank_code);
    } else if (accountEl && bankInfo.account_number) {
      setRowValue(accountEl, bankInfo.account_number, bankInfo.account_number);
    } else {
      setRowValue(accountEl, null);
    }
    
    // IBAN
    setRowValue(ibanEl, bankInfo.iban, bankInfo.iban);
    
    // Variable symbol
    setRowValue(varSymbolEl, bankInfo.var_symbol, bankInfo.var_symbol);
    
    // SWIFT
    setRowValue(swiftEl, bankInfo.bic_swift, bankInfo.bic_swift)
    
    // Wire up buttons
    var primaryBtn = document.getElementById('nch_bank_btn_primary');
    var secondaryBtn = document.getElementById('nch_bank_btn_secondary');
    
    if (primaryBtn) {
      primaryBtn.onclick = function() {
        window.location.href = redirectUrl;
      };
    }
    if (secondaryBtn) {
      secondaryBtn.onclick = function() {
        window.location.href = redirectUrl;
      };
    }
    
    // Show bank transfer state
    neviosCheckout__showLoadingOverlay('bank_transfer');
  };
  
  /**
   * Set error state on an input element
   * @param {HTMLElement} element - The input element
   * @param {boolean} hasError - Whether to show error state
   */
  window.neviosCheckout__setInputError = function(element, hasError) {
    if (!element) return;
    if (hasError) {
      element.setAttribute('state', 'error');
    } else {
      element.removeAttribute('state');
    }
  };

  /**
   * Clear all error states from form inputs
   */
  window.neviosCheckout__clearAllErrors = function() {
    var allInputs = document.querySelectorAll('input[state="error"], select[state="error"]');
    allInputs.forEach(function(input) {
      input.removeAttribute('state');
    });
    var allCheckboxWrappers = document.querySelectorAll('.nevios-checkbox-wrapper.error');
    allCheckboxWrappers.forEach(function(wrapper) {
      wrapper.classList.remove('error');
    });
    // Clear shipping and payment container errors
    var shippingContainer = document.querySelector('.nch_shipping_container.error');
    if (shippingContainer) shippingContainer.classList.remove('error');
    var paymentContainer = document.querySelector('.nch_payment_container.error');
    if (paymentContainer) paymentContainer.classList.remove('error');
  };

  /**
   * Validate all required form fields and terms acceptance.
   * Sets error state on invalid fields and scrolls to first error.
   * 
   * @returns {boolean} True if validation passes, false otherwise
   */
  window.neviosCheckout__validateForm = function() {
    var errorFields = [];
    var firstErrorElement = null;
  
    // Clear previous error states
    neviosCheckout__clearAllErrors();
  
    // Check required fields
    var requiredFields = [
      { id: 'customer_email', name: 'E-mail' },
      { id: 'customer_first_name', name: 'Jméno' },
      { id: 'customer_last_name', name: 'Příjmení' },
      { id: 'billing_address', name: 'Adresa' },
      { id: 'billing_city', name: 'Město' },
      { id: 'billing_zip', name: 'PSČ' },
      { id: 'phone', name: 'Telefon' }
    ];
  
    requiredFields.forEach(function(field) {
      var element = document.getElementById(field.id);
      if (!element || !element.value.trim()) {
        neviosCheckout__setInputError(element, true);
        errorFields.push({ element: element, name: field.name });
        if (!firstErrorElement && element) firstErrorElement = element;
      }
    });
  
    // Check email format
    var emailField = document.getElementById('customer_email');
    if (emailField && emailField.value.trim()) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailField.value.trim())) {
        neviosCheckout__setInputError(emailField, true);
        if (!firstErrorElement) firstErrorElement = emailField;
      }
    }
  
    // Check if shipping method is selected
    var selectedShipping = document.querySelector('input[name="shipping"]:checked');
    var shippingContainer = document.querySelector('.nch_shipping_container');
    if (!selectedShipping) {
      if (shippingContainer) {
        shippingContainer.classList.add('error');
      }
      if (!firstErrorElement && shippingContainer) firstErrorElement = shippingContainer;
    }
  
    // Check if payment method is selected
    var selectedPayment = document.querySelector('input[name="payment"]:checked');
    var paymentContainer = document.querySelector('.nch_payment_container');
    if (!selectedPayment) {
      if (paymentContainer) {
        paymentContainer.classList.add('error');
      }
      if (!firstErrorElement && paymentContainer) firstErrorElement = paymentContainer;
    }
  
    // Check terms acceptance (desktop or mobile)
    var acceptTerms = document.getElementById('acceptTerms');
    var acceptTermsMobile = document.getElementById('acceptTermsMobile');
    var termsChecked = (acceptTerms && acceptTerms.checked) || (acceptTermsMobile && acceptTermsMobile.checked);
    if (!termsChecked) {
      // Add error class to checkbox wrapper
      if (acceptTerms) {
        var wrapper = acceptTerms.closest('.nevios-checkbox-wrapper');
        if (wrapper) wrapper.classList.add('error');
        if (!firstErrorElement) firstErrorElement = acceptTerms;
      }
      if (acceptTermsMobile) {
        var wrapperMobile = acceptTermsMobile.closest('.nevios-checkbox-wrapper');
        if (wrapperMobile) wrapperMobile.classList.add('error');
      }
    }
  
    var acceptPrivacy = document.getElementById('acceptPrivacy');
    var acceptPrivacyMobile = document.getElementById('acceptPrivacyMobile');
    var privacyChecked = (acceptPrivacy && acceptPrivacy.checked) || (acceptPrivacyMobile && acceptPrivacyMobile.checked);
    if (!privacyChecked) {
      // Add error class to checkbox wrapper
      if (acceptPrivacy) {
        var wrapper = acceptPrivacy.closest('.nevios-checkbox-wrapper');
        if (wrapper) wrapper.classList.add('error');
        if (!firstErrorElement) firstErrorElement = acceptPrivacy;
      }
      if (acceptPrivacyMobile) {
        var wrapperMobile = acceptPrivacyMobile.closest('.nevios-checkbox-wrapper');
        if (wrapperMobile) wrapperMobile.classList.add('error');
      }
    }
  
    // Check different shipping address if enabled
    var differentShipping = document.getElementById('differentShipping');
    if (differentShipping && differentShipping.checked) {
      var shippingRequiredFields = [
        { id: 'shipping_first_name', name: 'Jméno (doručovací adresa)' },
        { id: 'shipping_last_name', name: 'Příjmení (doručovací adresa)' },
        { id: 'shipping_address', name: 'Adresa (doručovací adresa)' },
        { id: 'shipping_city', name: 'Město (doručovací adresa)' },
        { id: 'shipping_zip', name: 'PSČ (doručovací adresa)' }
      ];
  
      shippingRequiredFields.forEach(function(field) {
        var element = document.getElementById(field.id);
        if (!element || !element.value.trim()) {
          neviosCheckout__setInputError(element, true);
          errorFields.push({ element: element, name: field.name });
          if (!firstErrorElement && element) firstErrorElement = element;
        }
      });
    }
  
    // If there are errors, scroll to first error element
    if (errorFields.length > 0 || !selectedShipping || !selectedPayment || !termsChecked || !privacyChecked) {
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Focus the element if it's an input
        if (firstErrorElement.tagName === 'INPUT' || firstErrorElement.tagName === 'SELECT') {
          setTimeout(function() {
            firstErrorElement.focus();
          }, 500);
        }
      }
      return false;
    }
  
    return true;
  };
  
  /**
   * Build the payload for the convert API from form data.
   * 
   * @returns {Object|null} Payload object or null if error
   */
  window.neviosCheckout__buildPayload = function() {
    try {
      // Get selected shipping and payment methods
      var selectedShipping = document.querySelector('input[name="shipping"]:checked');
      var selectedPayment = document.querySelector('input[name="payment"]:checked');
  
      // Build customer object
      var customer = {
        email: document.getElementById('customer_email').value.trim(),
        first_name: document.getElementById('customer_first_name').value.trim(),
        last_name: document.getElementById('customer_last_name').value.trim(),
        phone: document.getElementById('phone').value.trim(),
        subscribed: window.acceptMarketing
      };
  
      // Build billing address
      var billing_address = {
        first_name: document.getElementById('customer_first_name').value.trim(),
        last_name: document.getElementById('customer_last_name').value.trim(),
        address: document.getElementById('billing_address').value.trim(),
        city: document.getElementById('billing_city').value.trim(),
        zip: document.getElementById('billing_zip').value.trim(),
        country: window.selectedCountry
      };
  
      // Add company data to billing address if provided
      if (window.enterCompany && window.enterCompany === true) {
        var companyName = document.getElementById('company_name');
        var companyId = document.getElementById('company_id');
        var companyVat = document.getElementById('company_vat');
        
        if (companyName && companyName.value.trim()) {
          billing_address.company = companyName.value.trim();
        }
        if (companyId && companyId.value.trim()) {
          billing_address.company_id = companyId.value.trim();
        }
        if (companyVat && companyVat.value.trim()) {
          billing_address.company_vat = companyVat.value.trim();
        }
      }
  
      // Build shipping address
      var shipping_address;
      
      if (window.differentShipping && window.differentShipping === true) {
        // Use different shipping address
        shipping_address = {
          first_name: document.getElementById('shipping_first_name').value.trim(),
          last_name: document.getElementById('shipping_last_name').value.trim(),
          address: document.getElementById('shipping_address').value.trim(),
          city: document.getElementById('shipping_city').value.trim(),
          zip: document.getElementById('shipping_zip').value.trim(),
          country: window.selectedCountry
        };
      } else {
        // Use billing address for shipping (excluding company fields)
        shipping_address = {
          first_name: billing_address.first_name,
          last_name: billing_address.last_name,
          address: billing_address.address,
          city: billing_address.city,
          zip: billing_address.zip,
          country: billing_address.country
        };
      }
  
      // Check shipping type and add appropriate fields
      var shippingType = selectedShipping.getAttribute('shipping-type');
      if (shippingType === 'POINT') {
        // For pickup points, we need point details from the widget
        var pointData = neviosCheckout__getPointData();
        if (pointData && pointData.point_id) {
          shipping_address.point_id = pointData.point_id;
          shipping_address.point_name = pointData.point_name;
          
          // Use point's address data to populate shipping address fields
          if (pointData.address) {
            shipping_address.address = pointData.address;
          }
          if (pointData.city) {
            shipping_address.city = pointData.city;
          }
          if (pointData.zip) {
            shipping_address.zip = pointData.zip;
          }
        } else {
          // Point data is required for POINT shipping type
          alert('Prosím vyberte výdejní místo');
          throw new Error('Point data required for POINT shipping type');
        }
      }
  
      // Build payload
      var payload = {
        customer: customer,
        billing_address: billing_address,
        shipping_address: shipping_address,
        shipping_set: selectedShipping.value,
        payment_set: selectedPayment.value
      };

      /* Attach the click/attribution context so the server-side tracking
         service can forward fbp/fbc/gclid/ttclid + GA4 client_id to Meta
         CAPI, Google Ads Enhanced and GA4 Measurement Protocol. Without
         these the server has no way to recover the original click that
         drove the conversion. */
      if (typeof window.n_p_clickContext === 'function') {
        var ctx = window.n_p_clickContext();
        if (ctx.fbp)          payload.fbp = ctx.fbp;
        if (ctx.fbc)          payload.fbc = ctx.fbc;
        if (ctx.fbclid)       payload.fbclid = ctx.fbclid;
        if (ctx.gclid)        payload.gclid = ctx.gclid;
        if (ctx.ttclid)       payload.ttclid = ctx.ttclid;
        if (ctx.msclkid)      payload.msclkid = ctx.msclkid;
        if (ctx.ga_client_id) payload.ga_client_id = ctx.ga_client_id;
      }

      console.log('[DEBUG] Built payload:', payload);
      return payload;
  
    } catch (error) {
      console.error('Error building payload:', error);
      alert('Chyba při zpracování formuláře. Zkuste to znovu.');
      return null;
    }
  };
  
  /**
   * Get pickup point data from the shipping widget.
   * Works with Packeta widget and other pickup point systems.
   * 
   * @returns {Object|null} Point data or null if not available
   */
  window.neviosCheckout__getPointData = function() {
    try {
      var selectedShipping = document.querySelector('input[name="shipping"]:checked');
      if (!selectedShipping) {
        console.warn('No shipping method selected');
        return null;
      }
  
      var shippingOption = selectedShipping.closest('.nch_shipping_option');
      if (!shippingOption) {
        console.warn('Shipping option container not found');
        return null;
      }
  
      var widget = shippingOption.querySelector('.nch_shipping_option_widget');
      if (!widget) {
        console.warn('Widget container not found');
        return null;
      }
      
      // Look for point data in the widget (stored by Packeta or other widgets)
      var pointIdElement = widget.querySelector('[data-point-id]');
      var pointNameElement = widget.querySelector('[data-point-name]');
      var pointAddressElement = widget.querySelector('[data-point-address]');
      var pointCityElement = widget.querySelector('[data-point-city]');
      var pointZipElement = widget.querySelector('[data-point-zip]');
      
      if (pointIdElement) {
        var pointData = {
          point_id: pointIdElement.getAttribute('data-point-id') || pointIdElement.value,
          point_name: pointNameElement ? (pointNameElement.getAttribute('data-point-name') || pointNameElement.value || pointNameElement.textContent) : null,
          address: pointAddressElement ? (pointAddressElement.getAttribute('data-point-address') || pointAddressElement.value) : null,
          city: pointCityElement ? (pointCityElement.getAttribute('data-point-city') || pointCityElement.value) : null,
          zip: pointZipElement ? (pointZipElement.getAttribute('data-point-zip') || pointZipElement.value) : null
        };
  
        console.log('Point data retrieved:', pointData);
        return pointData;
      }
      
      console.log('No point data found in widget');
      return null;
    } catch (error) {
      console.error('Error getting point data:', error);
      return null;
    }
  };
  
  /**
   * Handle the next step response from the convert API.
   * 
   * @param {Object} nextStep - Next step object from API response
   */
  window.neviosCheckout__handleNextStep = function(nextStep) {
    console.log('[DEBUG] Handling next step:', nextStep);
  
    neviosCheckout__deleteCookie("neviosCheckout");
    neviosCheckout__deleteCookie("cart");
    neviosCheckout__deleteCookie("cart_sig");
    
    if (!nextStep || !nextStep.type) {
      console.error('Invalid next step response');
      window.location.href = '/pages/status';
      return;
    }
  
    switch (nextStep.type) {
      case 'gateway':
        // Show gateway loading state then redirect
        neviosCheckout__showLoadingOverlay('gateway');
        if (nextStep.redirectUrl) {
          console.log('[DEBUG] Redirecting to gateway:', nextStep.redirectUrl);
          setTimeout(function() {
            window.location.href = nextStep.redirectUrl;
          }, 500);
        } else {
          console.error('Gateway redirect URL not provided');
          window.location.href = '/pages/status';
        }
        break;
        
      case 'bank_transfer':
        // Show bank transfer info
        console.log('[DEBUG] Showing bank transfer info:', nextStep.bank_info);
        var redirectUrl = nextStep.redirect_url || '/pages/status';
        neviosCheckout__showBankTransferOverlay(nextStep.bank_info, redirectUrl);
        break;
        
      case 'cod':
        // Show COD loading state then redirect
        neviosCheckout__showLoadingOverlay('cod');
        var codUrl = nextStep.redirect_url || '/pages/status';
        console.log('[DEBUG] Redirecting to COD confirmation:', codUrl);
        setTimeout(function() {
          window.location.href = codUrl;
        }, 1500);
        break;
        
      case 'status':
        // Redirect to status page
        var statusUrl = nextStep.redirect_url || '/pages/status';
        console.log('[DEBUG] Redirecting to status:', statusUrl);
        window.location.href = statusUrl;
        break;
        
      default:
        console.error('Unknown next step type:', nextStep.type);
        window.location.href = '/pages/status';
        break;
    }
  };
  
  // Wire up the confirm button when DOM is ready
  window.neviosCheckout__wireConfirmButton = function() {
    var confirmBtns = document.querySelectorAll('.nch_confirm_btn');
    confirmBtns.forEach(function(confirmBtn) {
      confirmBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.neviosCheckout__confirmOrder();
      });
    });
  };

  // Mobile Summary Accordion - toggle and discount button
  window.neviosCheckout__initMobileSummary = function() {
    var accordion = document.querySelector('.nch_mobile_summary_accordion');
    var toggle = document.querySelector('[data-mobile-summary-toggle]');
    
    if (toggle && accordion) {
      toggle.addEventListener('click', function() {
        accordion.classList.toggle('expanded');
      });
    }

    // Wire up mobile discount button (reuses the same applyDiscount logic)
    var mobileDiscountBtn = document.getElementById('discount_code_button_mobile');
    var mobileDiscountInput = document.getElementById('discount_code_input_mobile');
    
    if (mobileDiscountBtn && mobileDiscountInput) {
      // Enable/disable button based on input
      mobileDiscountBtn.classList.add('disabled');
      mobileDiscountBtn.disabled = true;
      
      mobileDiscountInput.addEventListener('input', function() {
        window.neviosCheckout__clearDiscountError(mobileDiscountInput);
        
        if (mobileDiscountInput.value.trim().length > 0) {
          mobileDiscountBtn.classList.remove('disabled');
          mobileDiscountBtn.disabled = false;
        } else {
          mobileDiscountBtn.classList.add('disabled');
          mobileDiscountBtn.disabled = true;
        }
      });
      
      mobileDiscountBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var code = mobileDiscountInput.value.trim();
        if (code) {
          window.neviosCheckout__applyDiscount(code, mobileDiscountInput);
        }
      });

      mobileDiscountInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var code = mobileDiscountInput.value.trim();
          if (code) {
            window.neviosCheckout__applyDiscount(code, mobileDiscountInput);
          }
        }
      });
    }
  };
  
  /***********************************************************************
                              Analytics
  ***********************************************************************/
  class Analytics {
    constructor(config = {}) {
      this.config = {
        apiEndpoint: config.apiEndpoint || '/a/api/storefront/session',
        autoTrackPageViews: config.autoTrackPageViews !== false,
        batchEvents: config.batchEvents !== false,
        batchSize: config.batchSize || 10,
        batchTimeout: config.batchTimeout || 5000,
        debug: config.debug || false,
        ...config
      };
      
      this.sessionId = null;
      this.deviceId = this.getOrCreateDeviceId();
      this.eventQueue = [];
      this.pendingEvents = []; // Events queued before session is ready
      this.batchTimer = null;
      this.sessionReady = false;
      this.retryCount = 0;

      this.init();
    }
    
    // Initialize the analytics system
    async init() {
      try {
        await this.restoreOrCreateSession();
        this.sessionReady = true;

        // Flush any events that were queued before session was ready
        if (this.pendingEvents.length > 0) {
          for (const pending of this.pendingEvents) {
            this.track(pending.eventName, pending.properties);
          }
          this.pendingEvents = [];
        }

        if (this.config.autoTrackPageViews) {
          this.trackPageView();
          this.setupPageViewTracking();
        }

        // Flush pending events on page unload so nothing is lost
        if (typeof window !== 'undefined') {
          window.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
              this.flushBatchSync();
            }
          });
        }

        this.log('Analytics initialized successfully');
      } catch (error) {
        console.error('Analytics initialization failed:', error);
      }
    }
    
    // Restore existing session or create new one
    async restoreOrCreateSession() {
      // Try to restore existing session from cookie/localStorage
      let existingSessionId = this.getCookie('_analytics_session_id');
      
      // Fallback to localStorage
      if (!existingSessionId && typeof localStorage !== 'undefined') {
        existingSessionId = localStorage.getItem('_analytics_session_id');
      }
      
      if (existingSessionId) {
        // Validate the session still exists on server and hasn't expired
        try {
          const response = await fetch(`${this.config.apiEndpoint}/retrieve/${existingSessionId}`);
          const result = await response.json();
          
          if (result.success && result.data) {
            // Check if session is still valid (within 30 minutes of last activity)
            const lastActivity = new Date(result.data.updated_at || result.data.created_at);
            const now = new Date();
            const timeDiff = now - lastActivity;
            const thirtyMinutes = 30 * 60 * 1000; // 30 minutes in milliseconds

            if (timeDiff < thirtyMinutes) {
              this.sessionId = existingSessionId;
              this.sessionGroupId = result.data.session_group_id;
              // Ensure cross-browser link tokens are on all links
              this.appendLinkTokenToLinks();
              this.log('Session restored:', existingSessionId);
              return result.data;
            } else {
              this.log('Session expired, creating new one');
              // Session expired, remove from storage
              this.clearSessionStorage();
            }
          } else {
            // Session doesn't exist on server, remove from storage
            this.clearSessionStorage();
          }
        } catch (error) {
          console.warn('Failed to validate existing session:', error);
          this.clearSessionStorage();
        }
      }
      
      // No valid existing session, create new one
      return await this.createSession();
    }
    
    // Clear session from all storage locations
    clearSessionStorage() {
      if (typeof document !== 'undefined') {
        document.cookie = '_analytics_session_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = '_analytics_session_group_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      }

      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('_analytics_session_id');
        localStorage.removeItem('_analytics_session_group_id');
      }

      this.sessionGroupId = null;
    }
    
    // Generate or retrieve device ID
    getOrCreateDeviceId() {
      // Try cookie first
      let deviceId = this.getCookie('_analytics_device_id');
      
      // Fallback to localStorage
      if (!deviceId && typeof localStorage !== 'undefined') {
        deviceId = localStorage.getItem('_analytics_device_id');
      }
      
      // Generate new if none exists
      if (!deviceId) {
        deviceId = this.generateId();
        this.setCookie('_analytics_device_id', deviceId, 365); // 1 year
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem('_analytics_device_id', deviceId);
        }
      }
      
      return deviceId;
    }
    
    // Create new session
    async createSession() {
      // Use the robust data collection methods
      const userData = await this.getUserData();

      // Check for cross-browser link token in URL (_nvt param)
      const linkToken = new URLSearchParams(window.location.search).get('_nvt') || null;

      const sessionData = {
        device_id: this.deviceId,
        ...userData,
        link_token: linkToken
      };

      try {
        const response = await fetch(`${this.config.apiEndpoint}/create`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(sessionData)
        });

        const result = await response.json();

        if (result.success) {
          this.sessionId = result.data.id;
          this.sessionGroupId = result.data.session_group_id;

          // Store session ID in cookie (30 minutes expiry)
          this.setCookie('_analytics_session_id', this.sessionId, 0.021); // 30 minutes = 0.021 days

          // Store session group ID for cross-browser linking
          if (this.sessionGroupId) {
            this.setCookie('_analytics_session_group_id', this.sessionGroupId, 365);
            if (typeof localStorage !== 'undefined') {
              localStorage.setItem('_analytics_session_group_id', this.sessionGroupId);
            }
          }

          // Also store in localStorage as fallback
          if (typeof localStorage !== 'undefined') {
            localStorage.setItem('_analytics_session_id', this.sessionId);
          }

          // Append _nvt param to all links for cross-browser tracking
          this.appendLinkTokenToLinks();

          // Clean _nvt from current URL (cosmetic, doesn't reload)
          if (linkToken) {
            this.cleanLinkTokenFromUrl();
          }

          this.log('Session created:', result.data);
          return result.data;
        } else {
          throw new Error(result.error || 'Failed to create session');
        }
      } catch (error) {
        console.error('Failed to create session:', error);
        throw error;
      }
    }
    
    // Track an event
    track(eventName, properties = {}) {
      if (!this.sessionId) {
        // Queue event — will be flushed when session is ready
        if (!this.sessionReady && this.pendingEvents.length < 50) {
          this.pendingEvents.push({ eventName, properties });
        }
        return;
      }
      
      const eventData = {
        session_id: this.sessionId,
        event_name: eventName,
        event_category: properties.category || this.inferEventCategory(eventName),
        page_url: window.location.href,
        page_title: document.title,
        referrer_url: document.referrer,
        properties: this.sanitizeProperties(properties),
        timestamp: new Date().toISOString()
      };
      
      if (this.config.batchEvents) {
        this.addToBatch(eventData);
      } else {
        this.sendEvent(eventData);
      }
      
      this.log('Event tracked:', eventName, properties);
    }
    
    // Track page view
    trackPageView(customProperties = {}) {
      const properties = {
        page_url: window.location.href,
        page_title: document.title,
        page_path: window.location.pathname,
        page_search: window.location.search,
        page_hash: window.location.hash,
        referrer: document.referrer,
        ...customProperties
      };
      
      this.track('page_view', properties);
    }
    
    // Identify customer
    async identify(customerId) {
      if (!this.sessionId) {
        console.warn('Analytics: Session not initialized for identify');
        return;
      }
      
      try {
        const response = await fetch(`${this.config.apiEndpoint}/link/${this.sessionId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            customer_id: customerId,
            link_method: 'frontend_identify'
          })
        });
        
        const result = await response.json();
        
        if (result.success) {
          this.log('Customer identified:', customerId);
          
          // Track identification event
          this.track('customer_identified', {
            customer_id: customerId,
            method: 'frontend_identify'
          });
          
          return result.data;
        } else {
          throw new Error(result.error || 'Failed to identify customer');
        }
      } catch (error) {
        console.error('Failed to identify customer:', error);
        throw error;
      }
    }
    
    // Batch event handling
    addToBatch(eventData) {
      this.eventQueue.push(eventData);
      
      if (this.eventQueue.length >= this.config.batchSize) {
        this.flushBatch();
      } else if (!this.batchTimer) {
        this.batchTimer = setTimeout(() => this.flushBatch(), this.config.batchTimeout);
      }
    }
    
    async flushBatch() {
      if (this.eventQueue.length === 0) return;

      const events = [...this.eventQueue];
      this.eventQueue = [];

      if (this.batchTimer) {
        clearTimeout(this.batchTimer);
        this.batchTimer = null;
      }

      try {
        const response = await fetch(`${this.config.apiEndpoint}/events/batch`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ events })
        });

        const result = await response.json();

        if (!result.success) {
          console.error('Batch event tracking failed:', result.error);
          if (this.retryCount < 3) {
            this.retryCount++;
            this.eventQueue.unshift(...events);
          }
        } else {
          this.retryCount = 0;
          this.log('Batch events sent:', events.length);
        }
      } catch (error) {
        console.error('Batch event tracking error:', error);
        if (this.retryCount < 3) {
          this.retryCount++;
          this.eventQueue.unshift(...events);
        }
      }
    }

    // Synchronous flush using sendBeacon for page unload
    flushBatchSync() {
      if (this.eventQueue.length === 0) return;

      const events = [...this.eventQueue];
      this.eventQueue = [];

      if (this.batchTimer) {
        clearTimeout(this.batchTimer);
        this.batchTimer = null;
      }

      try {
        const blob = new Blob([JSON.stringify({ events })], { type: 'application/json' });
        navigator.sendBeacon(`${this.config.apiEndpoint}/events/batch`, blob);
        this.log('Batch flushed via sendBeacon:', events.length);
      } catch (e) {
        // sendBeacon not supported, events lost — acceptable on unload
      }
    }
    
    // Send single event
    async sendEvent(eventData) {
      try {
        const response = await fetch(`${this.config.apiEndpoint}/event`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(eventData)
        });
        
        const result = await response.json();
        
        if (!result.success) {
          console.error('Event tracking failed:', result.error);
        }
      } catch (error) {
        console.error('Event tracking error:', error);
      }
    }
    
    // Setup automatic page view tracking for SPAs
    // Uses a single deduped mechanism to prevent multiple fires per navigation
    setupPageViewTracking() {
      let currentUrl = window.location.href;
      let pageViewTimer = null;

      const onUrlChange = () => {
        const newUrl = window.location.href;
        if (newUrl === currentUrl) return;
        currentUrl = newUrl;

        // Debounce — multiple signals (pushState + popstate) may fire together
        if (pageViewTimer) clearTimeout(pageViewTimer);
        pageViewTimer = setTimeout(() => {
          this.trackPageView();
          // Re-append link tokens to any new DOM links
          this.appendLinkTokenToLinks();
          pageViewTimer = null;
        }, 50);
      };

      // Listen for popstate (back/forward)
      window.addEventListener('popstate', onUrlChange);

      // Override pushState and replaceState
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;

      history.pushState = function(...args) {
        originalPushState.apply(history, args);
        onUrlChange();
      };

      history.replaceState = function(...args) {
        originalReplaceState.apply(history, args);
        onUrlChange();
      };
    }
    
    // Data collection methods
    async getUserIP() {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        if (!response.ok) {
          throw new Error('Failed to fetch IP address');
        }
        const data = await response.json();
        return data.ip;
      } catch (error) {
        console.error("Error fetching user IP:", error);
        return null;
      }
    }
    
    getDeviceType(userAgent) {
      if (/Windows/i.test(userAgent)) {
        return "Windows";
      }
      if (/Android/i.test(userAgent)) {
        return "Android";
      }
      if (/iPhone/i.test(userAgent)) {
        return "iPhone";
      }
      if (/iPad/i.test(userAgent)) {
        return "iPad";
      }
      if (/iPod/i.test(userAgent)) {
        return "iPod";
      }
      if (/Macintosh/i.test(userAgent)) {
        return "Mac";
      }
      return "Unknown";
    }
    
    getBrowserType(userAgent) {
      // Check for Samsung Internet first.
      if (userAgent.indexOf("SamsungBrowser") > -1) {
        return "Samsung Internet";
      }
      // Check for Microsoft Edge (both legacy and new Edge).
      if (userAgent.indexOf("Edg") > -1 || userAgent.indexOf("Edge") > -1) {
        return "Edge";
      }
      // Check for Mozilla Firefox.
      if (userAgent.indexOf("Firefox") > -1) {
        return "Mozilla";
      }
      // Check for Chrome, excluding Edge and Opera.
      if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1 && userAgent.indexOf("OPR") === -1) {
        return "Chrome";
      }
      // Check for Safari (but not Chrome).
      if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
        return "Safari";
      }
      // If it's an Android device and Chrome is not detected, assume Android Internet.
      if (userAgent.indexOf("Android") > -1 && userAgent.indexOf("Chrome") === -1) {
        return "Android Internet";
      }
      return "Other";
    }
    
    getUTMParameters() {
      const params = new URLSearchParams(window.location.search);
      // Sanitize: if a value contains '&' or 'utm_', the URL was malformed
      // e.g. utm_source=facebook&utm_medium=cpc parsed as one value
      const clean = (val) => {
        if (!val) return null;
        // Truncate at first '&' or 'utm_' occurrence within the value
        const ampIdx = val.indexOf('&');
        if (ampIdx > 0) val = val.substring(0, ampIdx);
        const utmIdx = val.indexOf('utm_');
        if (utmIdx > 0) val = val.substring(0, utmIdx);
        return val.trim() || null;
      };
      return {
        utm_source: clean(params.get('utm_source')),
        utm_medium: clean(params.get('utm_medium')),
        utm_campaign: clean(params.get('utm_campaign')),
        utm_content: clean(params.get('utm_content')),
        utm_term: clean(params.get('utm_term'))
      };
    }
    
    async getUserData() {
      const data = this.getUTMParameters();
      data.referrer = document.referrer || null;
      data.user_agent = navigator.userAgent || null; // raw user agent string
      data.browser = this.getBrowserType(navigator.userAgent) || null; // friendly browser name
      data.device = this.getDeviceType(navigator.userAgent);
      data.screen_width = screen.width || null;
      
      // Get current market configuration instead of localStorage
      try {
        const currentMarket = window.neviosConfig.getCurrentMarket();
        data.currency = currentMarket.currency || null;
        data.language = currentMarket.language || null;
        data.market = currentMarket.market || null;
        data.country = currentMarket.defaultCountry || null;
        
        this.log('Using market config:', currentMarket.marketKey, currentMarket);
      } catch (error) {
        console.error("Error getting market configuration:", error);
        // Fallback values
        data.currency = null;
        data.language = null;
        data.market = null;
        data.country = null;
      }
      
      // Fetch IP address
      data.ip_address = await this.getUserIP();
      
      return data;
    }
    
    // Utility methods
    generateId() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    
    getCookie(name) {
      if (typeof document === 'undefined') return null;
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
    
    setCookie(name, value, days) {
      if (typeof document === 'undefined') return;
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
    }
    
    inferEventCategory(eventName) {
      if (eventName.includes('page')) return 'navigation';
      if (eventName.includes('product') || eventName.includes('cart') || eventName.includes('checkout')) return 'ecommerce';
      if (eventName.includes('click') || eventName.includes('scroll') || eventName.includes('view')) return 'engagement';
      return 'custom';
    }
    
    sanitizeProperties(properties) {
      // Remove any sensitive data and ensure JSON serializable
      const sanitized = {};
      for (const [key, value] of Object.entries(properties)) {
        if (key.toLowerCase().includes('password') || key.toLowerCase().includes('token')) {
          continue; // Skip sensitive fields
        }
        if (typeof value === 'function') {
          continue; // Skip functions
        }
        sanitized[key] = value;
      }
      return sanitized;
    }
    
    // Get the session group ID (from memory, cookie, or localStorage)
    getSessionGroupId() {
      if (this.sessionGroupId) return this.sessionGroupId;
      let groupId = this.getCookie('_analytics_session_group_id');
      if (!groupId && typeof localStorage !== 'undefined') {
        groupId = localStorage.getItem('_analytics_session_group_id');
      }
      return groupId || null;
    }

    // Append _nvt (session group token) to all internal links on the page
    // This ensures "Open in browser" from in-app browsers carries the token
    appendLinkTokenToLinks() {
      const groupId = this.getSessionGroupId();
      if (!groupId) return;

      const currentHost = window.location.hostname;

      const addTokenToLink = (link) => {
        try {
          const url = new URL(link.href, window.location.origin);
          if (url.hostname !== currentHost) return;
          if (!url.protocol.startsWith('http')) return;
          if (url.searchParams.has('_nvt')) return;
          url.searchParams.set('_nvt', groupId);
          link.href = url.toString();
        } catch (e) {
          // Skip invalid URLs
        }
      };

      // Process existing links
      document.querySelectorAll('a[href]').forEach(addTokenToLink);

      // Watch for dynamically added links (lazy-loaded products, pagination, etc.)
      if (!this._linkObserver) {
        this._linkObserver = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType !== 1) continue;
              if (node.tagName === 'A' && node.href) addTokenToLink(node);
              if (node.querySelectorAll) {
                node.querySelectorAll('a[href]').forEach(addTokenToLink);
              }
            }
          }
        });
        this._linkObserver.observe(document.body, { childList: true, subtree: true });
      }

      this.log('Link token appended to internal links');
    }

    // Remove _nvt param from the URL bar without reloading
    cleanLinkTokenFromUrl() {
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.has('_nvt')) {
          url.searchParams.delete('_nvt');
          history.replaceState(null, '', url.toString());
        }
      } catch (e) {
        // Ignore errors
      }
    }

    log(...args) {
      if (this.config.debug) {
        console.log('[Analytics]', ...args);
      }
    }
  }
  
  if (typeof window !== 'undefined') {
    window.Analytics = Analytics;
    
    // Create global instance
    window.analytics = new Analytics({
      debug: window.location.hostname === 'localhost' // Debug mode for local development
    });
  }